<template>
  <div id="hmsDiagram-app" @mousemove="moveTooltip($event)" @mouseup="dropTooltip($event)">
    <div class="main-container">
      <div class="animation-title-container">
        <div class="animation-title">
          <u id="label-title" style="text-decoration-color: #EE9D26;" :class="{'text-locale-jp-large': i18n.locale.value === 'ja-JP'}">
            {{ $t('TOTALREQ.HLTHMNGMNTREQMNTANIMATION') }}
          </u>
          <div class="tooltip-question-mark mark-animation-title" style="bottom: 2px; right: 5px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" viewBox="0 0 512 512"
              :class="{ 'tooltip-active': keepTooltipsIds.includes('page-title') }"
              @mouseenter="showTooltipByOpt($event, false, false)"
              @mouseleave="closeTooltip()"
              @click.left.stop.prevent="keepTooltipOpen($event, false, false, 0, 0, '', 'page-title', $t('TOOLTIP.ANIMATIONTITLE'))"
              :data-tooltipHeader = "' '"
              :data-tooltipContent = "$t('TOOLTIP.ANIMATIONTITLE')"
            >
              <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
              <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
            </svg>
          </div>
        </div>
      </div> 
      <div class="top-container">
       <div class="flexend-container">
        <!--Activity buttons-->
        <div class="activities-container">
          <div>
            <div class="label" :class="{'text-locale-jp-mid': i18n.locale.value === 'ja-JP'}">{{$t("ACTIVITIES.ACTIVITIES")}}</div>
            <div v-for="(period, i) in activitiesForDisplay" :key="i" class="activity-container" :class="{ 'acty-2': period.activities.length > 1 }">
              <div class="label" :class="{'text-locale-jp-mid': i18n.locale.value === 'ja-JP'}" >
                {{$t('PERIOD.' + period.period )}}
              </div>
              <div class="actbtn-containers">
                <template v-for="(acty, j) in period.activities" :key="j">
                  <button :id="`acty${acty.steps[0]}`"
                    class="actbtn acty" :class="{inactive : !actyDisplayCondition(acty.steps[0]), 'activeActvt' : selectedActvt == acty.steps[0], 'text-locale-jp': i18n.locale.value === 'ja-JP' }"
                    @click.stop="animate(acty.steps)"
                  >
                    {{$t("ACTIVITIES." + acty.title )}}
                    <div class="tooltip-question-mark" style="bottom: -2px; right: -2px;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512"
                        :class="{ 'tooltip-active': keepTooltipsIds.includes(period.period + $t('ACTIVITIES.' + acty.title)) }"
                        @mouseenter="showTooltipByOpt($event, false, true, 0, acty.posY)"
                        @mouseleave="closeTooltip()"
                        @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, acty.posY, $t('PERIOD.' + period.period) + ' - ' + $t('ACTIVITIES.' + acty.title), period.period + $t('ACTIVITIES.' + acty.title), $t('TOOLTIP.' + getTooltipContent(`acty${acty.steps[0]}`)))"
                        :data-tooltipHeader = "$t('PERIOD.' + period.period) + ' - ' + $t('ACTIVITIES.' + acty.title)"
                        :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent(`acty${acty.steps[0]}`))"
                      >
                        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                        <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      </svg>
                    </div>
                  </button>
                </template>
              </div>
            </div>
          </div>
        </div>
       </div>
        <div style="position: relative;">
          <div style="display: flex; gap: 16px; margin-top: 10px;">
            <div class="company-container">
              <div class="filter-content container-box">
                <!-- company type -->
                <div>
                  <div class="filter-title" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("FILTERTITLE.COMPANYTYPE")}}</div>
                  <div id="filter-type">
                    <label v-for="(type, i) in filterCompanyTypes" :key="i" :for="type.label" class="filter-subtitle" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">
                      <input type="radio" :id="type.label" :value="type.label" v-model="coType" @click="removeFocus($event)"/>
                      <span>{{$t("FILTER." + type.content)}}</span>
                    </label>
                  </div>
                </div>
                <!-- company size -->
                <div>
                  <div class="filter-title" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">
                    {{$t("FILTERTITLE.NUMBEREMPLOYEES")}}
                  </div>
                  <div id="filter-size">
                    <div id="filter-box-size" style="display: flex; gap: 10px">
                      <vue-slider id="slider" v-model="size" :data="sizes" :marks="marks" direction="ltr" :width="300" :tooltip-style="{background: '#928d22', borderColor: '#928d22'}"/>
                    </div>
                  </div>
                </div>
                <div class="tooltip-question-mark" style="bottom: 3px; right: 5px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('filter') }"
                    @mouseenter="showTooltipByOpt($event, false, true, 4, -52)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, false, true, 4, -52, $t('TOTALREQ.FILTERDETAIL'), 'filter', $t('TOOLTIP.FILTERDETAIL'))"
                    :data-tooltipHeader = "$t('TOTALREQ.FILTERDETAIL')"
                    :data-tooltipContent = "$t('TOOLTIP.FILTERDETAIL')"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!--Diagram-->
          <svg class="svg-main">
            <defs>
              <marker id="arrowhead" markerWidth="3.2" markerHeight="3.2"
                refX="0" refY="1.6" orient="auto" fill="#C4BD97">
                <polygon points="0 0, 3.2 1.6, 0 3.2"/>
              </marker>
              <marker id="arrowheadDark" markerWidth="1.7" markerHeight="1.7"
                refX="0" refY="0.85" orient="auto" fill="#C4BD97">
                <polygon points="0 0, 1.7 0.85, 0 1.7" />
              </marker>
              <filter id="shadow-block-inner-top" >            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='10'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='white' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-block-inner-top2" >            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='4'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='#C4BD97' flood-opacity='1' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-block-inner-bottom" >            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='-5'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='black' flood-opacity='.7' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-team-inner-top" >            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='6'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='black' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-team-inner-right" >            
                <!-- Shadow offset -->
                <feOffset dx='-6' dy='-1'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='black' flood-opacity='.3' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-team-inner-bottom" >            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='-5'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='#EFEEDD' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-team-inner-left" >            
                <!-- Shadow offset -->
                <feOffset dx='6' dy='-1'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='black' flood-opacity='.2' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-line-right" filterUnits="userSpaceOnUse">            
                <feDropShadow dx="8" dy="3" stdDeviation="3" flood-opacity='.4' />
              </filter>
              <filter id="shadow-line-block-inner-top" filterUnits="userSpaceOnUse">            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='3'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='1' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='white' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-line-block-inner-top2" filterUnits="userSpaceOnUse">            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='1'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='1' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='#C4BD97' flood-opacity='1' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-line-block-inner-bottom" >            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='-3'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='black' flood-opacity='.7' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-line-block-inner-left" filterUnits="userSpaceOnUse">            
                <!-- Shadow offset -->
                <feOffset dx='4' dy='-2'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='white' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-line-block-inner-left2" filterUnits="userSpaceOnUse">            
                <!-- Shadow offset -->
                <feOffset dx='3' dy='0'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='#C4BD97' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-line-block-inner-right" filterUnits="userSpaceOnUse">            
                <!-- Shadow offset -->
                <feOffset dx='-1' dy='2'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='2' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='black' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-dot-inner-top" filterUnits="userSpaceOnUse">            
                <!-- Shadow offset -->
                <feOffset dx='0' dy='0.5'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='1.5' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='white' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
              <filter id="shadow-dot-inner-right" filterUnits="userSpaceOnUse">            
                <!-- Shadow offset -->
                <feOffset dx='-2' dy='-2'/>
                <!-- Shadow blur -->
                <feGaussianBlur stdDeviation='1' result='offset-blur'/>
                <!-- Invert drop shadow to make an inset shadow-->
                <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
                <!-- Cut colour inside shadow -->
                <feFlood flood-color='black' flood-opacity='.5' result='color'/>
                <feComposite operator='in' in='color' in2='inverse' result='shadow'/>
                <!-- Placing shadow over element -->
                <feComposite operator='over' in='shadow' in2='SourceGraphic'/> 
              </filter>
            </defs>
            <g transform="translate(-6 -20)">
              <!-- ARROWS BELOW TEAM-->              
              <!--Health Check Arrow Below Team box-->
              <template v-if="selectedActvt == healthChecksteps[0]">
                <!--Regular Employees to Health Clinic-->
                <g v-if="currentStep >= getActyStepIndex(healthChecksteps[1], 'EmptoClinic')"
                  class="fade-in"
                  :style="`stroke-dasharray: 734; stroke-dashoffset: 734; animation-duration:${ getArrowLineDuration(1050, 16, 50, 366, 760, 1100, 760, healthChecksteps[1], 'EmptoClinic')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1], 'EmptoClinic').delay }s;`"
                >
                  <line class="arrowtan shadow-line show-arrow-head" x1="366" y1="760" x2="1100" y2="760"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(1050, 16, 50, 366, 760, 1100, 760, healthChecksteps[1], 'EmptoClinic') - 0.25 + getActyStepByStepNm(healthChecksteps[1], 'EmptoClinic').delay}s;`"  
                  />
                  <text x="1108" y="765" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'EmptoClinic')}"
                    :style="[ (currentStep >= getActyStepIndex(healthChecksteps[1], 'EmptoClinic')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(1050, 16, 50, 366, 760, 1100, 760, healthChecksteps[1], 'EmptoClinic') - 0.1 + getActyStepByStepNm(healthChecksteps[1], 'EmptoClinic').delay }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('EmptoClinic') }}
                  </text>
                </g>
                <!--Health Clinic to Regular Employees arrow-->
                <g v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'EmpClinictoComp')"
                  class="fade-in"
                  :style="`stroke-dasharray: 698; stroke-dashoffset: 698; animation-duration:${ getArrowLineDuration(366, 16, 50, 1168, 678, 470, 678, healthChecksteps[1], 'EmpClinictoComp') }s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1], 'EmpClinictoComp').delay }s;`"
                >
                  <line class="arrowtan shadow-line show-arrow-head" x1="1168" y1="678" x2="470" y2="678"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(366, 16, 50, 1168, 678, 470, 678, healthChecksteps[1], 'EmpClinictoComp') - 0.25 + getActyStepByStepNm(healthChecksteps[1], 'EmpClinictoComp').delay }s;`"
                  />
                  <text x="452" y="682" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'EmpClinictoComp')}"
                    :style="[ (currentStep >= getActyStepIndex(healthChecksteps[1], 'EmpClinictoComp')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(366, 16, 50, 1168, 678, 470, 678, healthChecksteps[1], 'EmpClinictoComp') - 0.1  + getActyStepByStepNm(healthChecksteps[1], 'EmpClinictoComp').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('EmpClinictoComp') }}
                  </text>
                </g>
                <!--Health Clinic to Industrial Physician-->
                <g v-if="needsIndusPhysician &&
                          ((currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportClinictoIndusPhysician')))"
                  class="fade-in"
                  :style="`stroke-dasharray: 212; stroke-dashoffset: 212; animation-duration:${ getArrowLineDuration(336, 29, 30, 1244, 696, 1244, 484, healthChecksteps[1], 'ReportClinictoIndusPhysician') }s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1], 'ReportClinictoIndusPhysician').delay }s;`"
                >
                  <line class="arrowtan shadow-line show-arrow-head" x1="1244" y1="696" x2="1244" y2="484"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(336, 29, 30, 1244, 696, 1244, 484, healthChecksteps[1], 'ReportClinictoIndusPhysician') - 0.25 }s;`"
                  />
                  <text x="1239" y="475" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportClinictoIndusPhysician')}"
                    :style="[ (currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportClinictoIndusPhysician')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(336, 29, 30, 1244, 696, 1244, 484, healthChecksteps[1], 'ReportClinictoIndusPhysician') - 0.1 }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportClinictoIndusPhysician') }}
                  </text>
                </g>
                <!--Industrial Physician to Records-->
                <g v-if="needsIndusPhysician && currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoRecords')" class="fade-in"
                  :style="`stroke-dasharray: 491; stroke-dashoffset: 491; animation-duration:${ getArrowPathDuration(491, 720, 804, healthChecksteps[1], 'ReportIndusPhysiciantoRecords') }s; animation-delay: ${getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoRecords').delay}s;`"
                >
                  <path class="arrowtan shadow-line-curve-down show-arrow-head" d="M 1230 390 C 1230 390, 1230 558, 804 558"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(491, 720, 804, healthChecksteps[1], 'ReportIndusPhysiciantoRecords') - 0.25 + getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoRecords').delay}s;`"  
                  />
                  <text x="786" y="563" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoRecords')}"
                    :style="[ (currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoRecords')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(491, 720, 804, healthChecksteps[1], 'ReportIndusPhysiciantoRecords') - 0.1 + getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoRecords').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportIndusPhysiciantoRecords')  }}
                  </text>
                </g>
                <!--Industrial Physician to Team-->
                <g v-if="selectedActvt == healthChecksteps[0] && needsIndusPhysician &&
                         (currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoTeam'))"
                  class="fade-in"
                  :style="`stroke-dasharray: 754; stroke-dashoffset: 754; animation-duration:${getArrowLineDuration(314, 50, 50, 1224, 358, 470, 358, healthChecksteps[1], 'ReportIndusPhysiciantoTeam')}s; animation-delay:${getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoTeam').delay }s;`"
                >
                  <line class="arrowtan shadow-line show-arrow-head" x1="1224" y1="358" x2="470" y2="358"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(314, 50, 50, 1224, 358, 470, 358, healthChecksteps[1], 'ReportIndusPhysiciantoTeam') - 0.25 + getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoTeam').delay }s;`"
                  />
                  <text x="452" y="362" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoTeam')}"
                    :style="[ (currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoTeam')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(314, 50, 50, 1224, 358, 470, 358, healthChecksteps[1], 'ReportIndusPhysiciantoTeam') - 0.1 + getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoTeam').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportIndusPhysiciantoTeam') }}
                  </text>
                </g>
              </template>

              <!-- Stress Check Arrow -->
              <template v-if="selectedActvt === stressChecksteps[0] && actyDisplayCondition(stressChecksteps[0])">
                <!-- Stress Test Employee to Laptop -->
                <g v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'ReportEmptoLaptop')"
                  class="fade-in"
                  :style="`stroke-dasharray: 314; stroke-dashoffset: 314; animation-duration:${ getArrowLineDuration(699,30,30,270,749,584,749,stressChecksteps[1],'ReportEmptoLaptop') }s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1], 'ReportEmptoLaptop').delay }s;`"
                >
                  <line class="arrowtan shadow-line-left show-arrow-head" x1="270" y1="749" x2="584" y2="749"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowLineDuration(699,30,30,270,749,584,749,stressChecksteps[1],'ReportEmptoLaptop') - 0.25 + getActyStepByStepNm(stressChecksteps[1], 'ReportEmptoLaptop').delay}s;`"    
                  />
                  <text x="592" y="754" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1],'ReportEmptoLaptop')}"
                    :style="[ currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportEmptoLaptop') ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(699,30,30,270,749,584,749,stressChecksteps[1],'ReportEmptoLaptop') - 0.1 + getActyStepByStepNm(stressChecksteps[1], 'ReportEmptoLaptop').delay}s; opacity: 0;` : '' ]" 
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportEmptoLaptop') }}
                  </text>
                </g>

                <!-- Laptop to Employees -->
                <g v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoEmp')"
                  class="fade-in"
                  :style="`stroke-dasharray: 231; stroke-dashoffset: 231; animation-duration:${ getArrowLineDuration(262,30,30,702,698,471,698,stressChecksteps[1],'ReportLaptoptoEmp') }s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1], 'ReportLaptoptoEmp').delay }s`"
                >
                  <line class="arrowtan shadow-line show-arrow-head" x1="702" y1="698" x2="471" y2="698"          
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowLineDuration(262,30,30,702,698,471,698,stressChecksteps[1],'ReportLaptoptoEmp') - 0.25 + getActyStepByStepNm(stressChecksteps[1], 'ReportLaptoptoEmp').delay}s;`"   
                  />
                  <text x="454" y="703" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoEmp')}"
                    :style="[ (currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportLaptoptoEmp')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(262,30,30,702,698,471,698,stressChecksteps[1],'ReportLaptoptoEmp') - 0.1 + getActyStepByStepNm(stressChecksteps[1], 'ReportLaptoptoEmp').delay}s; opacity: 0;` : '' ]" 
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportLaptoptoEmp') }}
                  </text>
                </g>

                <!-- Laptop to Industrial Physician -->
                <g v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoIndusPhysician')"
                  class="fade-in"
                  :style="`stroke-dasharray: 613; stroke-dashoffset: 613; animation-duration:${ getArrowPathDuration(613, 362, 482, stressChecksteps[1], 'ReportLaptoptoIndusPhysician') }s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1], 'ReportLaptoptoIndusPhysician').delay }s`"
                >
                  <path class="arrowtan shadow-line-left show-arrow-head" d="M702,702 C702,702 1244,640 1244,482"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(613, 362, 482, stressChecksteps[1], 'ReportLaptoptoIndusPhysician') - 0.25 + getActyStepByStepNm(stressChecksteps[1], 'ReportLaptoptoIndusPhysician').delay}s;`"  
                  />
                  <text x="1239" y="474" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoIndusPhysician')}"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(613, 362, 482, stressChecksteps[1], 'ReportLaptoptoIndusPhysician') - 0.1 + getActyStepByStepNm(stressChecksteps[1], 'ReportLaptoptoIndusPhysician').delay}s; opacity: 0;`" 
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportLaptoptoIndusPhysician') }}
                  </text>
                </g>
                <!--Industrial Physician to Team-->
                <g v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'ReportIndusPhysiciantoTeam')"
                  class="fade-in"
                  :style="`stroke-dasharray: 774; stroke-dashoffset: 774; animation-duration:${getArrowLineDuration(338, 50, 50, 1218, 414, 470, 414, stressChecksteps[1], 'ReportIndusPhysiciantoTeam')}s; animation-delay: ${getActyStepByStepNm(stressChecksteps[1], 'ReportIndusPhysiciantoTeam').delay }s;`"
                  transform="translate(0 0)"
                >
                  <line class="arrowtan shadow-line show-arrow-head" x1="1243" y1="414" x2="470" y2="414"
                    :style="`animation-duration: 0.25s; animation-delay: ${getArrowLineDuration(338, 50, 50, 1218, 414, 470, 414, stressChecksteps[1], 'ReportIndusPhysiciantoTeam') - 0.25 + getActyStepByStepNm(stressChecksteps[1], 'ReportIndusPhysiciantoTeam').delay}s;`"
                  />
                  <text x="452" y="419" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1],'ReportIndusPhysiciantoTeam')}"
                    :style="[ (currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportIndusPhysiciantoTeam')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(338, 50, 50, 1218, 414, 470, 414, stressChecksteps[1], 'ReportIndusPhysiciantoTeam') - 0.1 + getActyStepByStepNm(stressChecksteps[1], 'ReportIndusPhysiciantoTeam').delay}s; opacity: 0;` : '' ]"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportIndusPhysiciantoTeam') }}
                  </text>
                </g>
              </template>

              <!-- Monthly Workplace Inspection Arrow -->
              <template v-if="selectedActvt === mnthlywrkplcinspctsteps[0] && actyDisplayCondition(mnthlywrkplcinspctsteps[0])">
                <!-- Industrial Physician to Facilities -->
                <g v-if="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'IndusPhysiciantoFacilities')"
                  class="fade-in"
                  :style="`stroke-dasharray: 441; stroke-dashoffset: 441; animation-duration:${ getArrowPathDurationByIconDistance(441, 514, mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities')}s; animation-delay: ${ getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities').delay }s;`"
                >
                  <path class="arrowtan shadow-line-left show-arrow-head" d="M1236,330 C1192,280 880,274 804,270"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDurationByIconDistance(441, 514, mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities') - 0.25 + getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities').delay }s;`"  
                  />  
                  <text x="783" y="274" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'IndusPhysiciantoFacilities') }"
                    :style="[ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'IndusPhysiciantoFacilities') ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDurationByIconDistance(441, 514, mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities') - 0.1 + getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities').delay }s; opacity: 0;` : '']"
                    >
                    {{ selectedActyStepsNoEmpty.indexOf('IndusPhysiciantoFacilities') }}
                  </text>
                </g>
                <!-- Industrial Physician to Team arrow -->
                <g v-if="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'ReportIndusPhysiciantoTeam')"
                  class="fade-in"
                  :style="`stroke-dasharray: 774; stroke-dashoffset: 774; animation-duration:${getArrowLineDuration(338, 50, 50, 1218, 414, 470, 414, mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam')}s; animation-delay: ${getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam').delay }s;`"
                  transform="translate(0 0)"
                >
                  <line class="arrowtan shadow-line show-arrow-head" x1="1243" y1="414" x2="470" y2="414"
                    :style="`animation-duration: 0.25s; animation-delay: ${getArrowLineDuration(338, 50, 50, 1218, 414, 470, 414, mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam') - 0.25 + getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam').delay}s;`"
                  />
                  <text x="452" y="419" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'ReportIndusPhysiciantoTeam')}"
                    :style="[ (currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowLineDuration(338, 50, 50, 1218, 414, 470, 414, mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam') - 0.1 + getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam').delay}s; opacity: 0;` : '' ]"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportIndusPhysiciantoTeam') }}
                  </text>
                </g>
              </template> 

              <!-- Health Committee Meeting Arrow Below Team -->
              <template v-if="selectedActvt === commttMtgsteps[0] && actyDisplayCondition(commttMtgsteps[0])">
                <!--Industrial Physician to Company-->
                <g v-if="currentStep >= getActyStepIndex(commttMtgsteps[1],'IndusPhysiciantoComp')"
                  class="fade-in"
                  :style="`stroke-dasharray: 765; stroke-dashoffset: 765; animation-duration:${ getArrowLineDuration(376, 16, 50, 1100, 350, 471, 350, commttMtgsteps[1], 'IndusPhysiciantoComp') }s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1], 'IndusPhysiciantoComp').delay }s;`"
                >
                  <line class="arrowtan shadow-line-left show-arrow-head" x1="1236" y1="350" x2="471" y2="350"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowLineDuration(376, 16, 50, 1100, 350, 471, 350, commttMtgsteps[1], 'IndusPhysiciantoComp') - 0.25 + getActyStepByStepNm(commttMtgsteps[1], 'IndusPhysiciantoComp').delay}s;`"  
                  />
                  <text x="454" y="355" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(commttMtgsteps[1],'IndusPhysiciantoComp')}"
                    :style="[ (currentStep >= getActyStepIndex(commttMtgsteps[1], 'IndusPhysiciantoComp')) ? `animation-duration: 0.25s; animation-delay: ${  getArrowLineDuration(376, 16, 50, 1100, 350, 471, 350, commttMtgsteps[1], 'IndusPhysiciantoComp') - 0.1 + getActyStepByStepNm(commttMtgsteps[1], 'IndusPhysiciantoComp').delay }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('IndusPhysiciantoComp') }}
                  </text>
                </g>
              </template>

              <!-- Weekly Workplace Inspection Arrow Below Team-->
              <template v-if="selectedActvt === weeklywrkplcinspctsteps[0] && actyDisplayCondition(weeklywrkplcinspctsteps[0])">
                <!--Health Officer to Facilities -->
                <g v-if="currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1], 'OfficertoFacilities')"
                  class="fade-in"
                  :style="`stroke-dasharray: 400; stroke-dashoffset: 400; animation-duration:${ getArrowPathDurationByIconDistance(400, 1284, weeklywrkplcinspctsteps[1], 'OfficertoFacilities') }s; animation-delay: ${ getActyStepByStepNm(weeklywrkplcinspctsteps[1], 'OfficertoFacilities').delay }s;`"
                >
                  <path class="arrowtan shadow-line-curve-down show-arrow-head" d="M182,388 C182,276 410,276 410,276 H532"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDurationByIconDistance(400, 1284, weeklywrkplcinspctsteps[1], 'OfficertoFacilities') - 0.25 + getActyStepByStepNm(weeklywrkplcinspctsteps[1], 'OfficertoFacilities').delay}s;`" 
                  />
                  <text x="540" y="282" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1], 'OfficertoFacilities')}"
                    :style="[ (currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1], 'OfficertoFacilities')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDurationByIconDistance(400, 1284, weeklywrkplcinspctsteps[1], 'OfficertoFacilities') - 0.1 + getActyStepByStepNm(weeklywrkplcinspctsteps[1], 'OfficertoFacilities').delay }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('OfficertoFacilities') }}
                  </text>
                </g>
              </template>
              
              <!--Regular Employees-->
              <g>
                <rect class="big-block shadow-block" height="162" x="20" y="638" rx="10" fill="#C4BD97"/>
                <text :x="i18n.locale.value === 'en-US' ? 175 : 193" y="660" class="memberboxtitle-large" :class="{'text-locale-jp2': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.EMPLOYEESTITLE" )}}</text>
                <g transform="translate(410, 375)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('employee-title') }"
                    @mouseenter="showTooltipByOpt($event, false, true, 0, getTooltipPosY('employee-title'), 0)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, getTooltipPosY('employee-title'), $t('DIAGRAM.EMPLOYEESTITLE'), 'employee-title', $t('TOOLTIP.' + getTooltipContent('employees')), 0)"
                    :data-tooltipHeader = "$t('DIAGRAM.EMPLOYEESTITLE')"
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('employees'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <!-- Not moving tan employees -->
                <template v-for="num in [7,6,2]" :key="num">
                  <foreignObject v-if="size >= num" :x="(262 - 20*(num - 1))" y="696" class="icon-member">
                    <Person type="memberInactive" size="small1"/>
                  </foreignObject>
                </template>
                <template v-if="size >= 8">
                  <circle v-for="i in 3" :key="i" :cx="196 + 12*i" cy="740" r="2" fill="#969462" />
                </template>
                <template v-for="num in [4,3]" :key="num">
                  <foreignObject v-if="size >= num && size < 8" :x="(262 - 20*(num - 1))" y="696" class="icon-member">
                    <Person type="memberInactive" size="small1"/>
                  </foreignObject>
                </template>
                <foreignObject v-if="size >= 5 && (!selectedActvt || selectedActvt !== prsnlAppntmntsteps[0] || !actyDisplayCondition(selectedActvt))" x="182" y="696" class="icon-member">
                  <Person type="memberInactive" size="small1"/>
                </foreignObject>
                <foreignObject v-if="!selectedActvt || ![healthChecksteps[0], stressChecksteps[0], prsnlAppntmntsteps[0],incdntRprtngsteps[0]].includes(selectedActvt) || !actyDisplayCondition(selectedActvt)" x="262" y="696" class="icon-member">
                  <Person type="memberInactive" size="small1"/>
                </foreignObject>
              </g>

              <!--Team-->
              <g id="team">
                <rect class="border-box big-block shadow-block" height="570" x="20" y="40" rx="10"
                />
                <g transform="translate(0 28)">
                  <text :x="i18n.locale.value === 'en-US' ? 135 : 144" y="36" class="memberboxtitle-large" :class="{'text-locale-jp2': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.TEAMTITLE")}}</text>
                  <template v-for="(row, r) in [
                    { name: 'MANAGERS', posX: 128, posXJp: 132 }, 
                    { name: 'PROMOTERS', posX: 128, posXJp: 146 }, 
                    { name: 'OFFICERS', posX: 136, posXJp: 146 }, 
                    { name: 'REPRESENTATIVES', posX: 118, posXJp: 154 },
                  ]" :key="r">
                    <text :x="i18n.locale.value === 'en-US' ? row.posX : row.posXJp" :y="i18n.locale.value === 'en-US' ? (83 + r*124) : (82 + r*124)" 
                      class="memberboxtitle" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}"
                    >
                      {{ $t(`TOTALREQ.${ row.name}`) }}
                    </text>
                    <line x1="36" :y1="84 + r*124" x2="302" :y2="84 + r*124" stroke="#494127" stroke-width="1" />
                    <g v-for="(member, i) in teamLoop.slice(r*2,r*2+2)" :key="i" :class="{ inactivemember : member.conditionInactive }">
                      <text :x="[ i % 2 === 0 ? 38 : 186 ]" :y="104 + r*124" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("TOTALREQ." + member.text1Content)}}</text>
                      <rect :x="[ i % 2 === 0 ? 36 : 180 ]" :y="[108 + r*124]" class="team-member-box"/>
                      <foreignObject :x="[ i % 2 === 0 ? 48 : 192 ]" :y="112 + r*124" class="icon-member">
                        <template v-if="
                          !(member.conditionInactive || (
                            (selectedActvt === setupsteps[0] && currentStep < getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam')) ||
                            (selectedActvt === commttMtgsteps[0] && currentStep > getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') && currentStep < getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam'))
                          ))"
                        >
                          <Person v-show="!(prsnlAppntmntsteps[0] === selectedActvt && (
                              (i === 1 && 'hlthPromoter' === member.iconType) ||
                              (i === 0 && 'hlthSftyPromoter' === member.iconType)
                            ))"
                            type="memberActive" size="small1"
                            :class="[
                              { 'icon-fade-out': selectedActvt === commttMtgsteps[0] && currentStep === getActyStepIndex(commttMtgsteps[1], 'AnimateMtg')},
                              { 'icon-fade-in': (
                                (selectedActvt === setupsteps[0] && currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < setupsteps[1].length - 1) ||
                                (selectedActvt === commttMtgsteps[0] && currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < commttMtgsteps[1].length - 1)
                              )}
                            ]"
                            :style="[
                              [ (
                                  (selectedActvt === setupsteps[0] && currentStep <= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < setupsteps[1].length - 1) ||
                                  (selectedActvt === commttMtgsteps[0] && currentStep < commttMtgsteps[1].length - 1) && 
                                  [getActyStepIndex(commttMtgsteps[1], 'AnimateMtg'),getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')].includes(currentStep) 
                                ) 
                                ? 'opacity: 0;' : ''],
                              [ selectedActvt === commttMtgsteps[0] && currentStep === getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimateMtg')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimateMtg').delay}s;` : '' ],
                              [ selectedActvt === setupsteps[0] && currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(setupsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(setupsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ],
                              [ selectedActvt === commttMtgsteps[0] && currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ]
                            ]"
                          />
                        </template>
                      </foreignObject>
                    </g>
                  </template>  
                  <g :class="{ inactivemember : nbHlthOfficer <= 0 }">
                    <text x="186" y="352" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("TOTALREQ.HEALTH")}}</text>
                    <rect x="180" y="356" class="team-member-box"/>
                    <foreignObject v-for="(n,i) in nbHlthOfficer" :key="n.id" :x="182 + i*16" y="360" class="icon-member">
                      <template v-if="!(
                        ((selectedActvt === setupsteps[0] && currentStep < getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam')) ||
                        (selectedActvt === commttMtgsteps[0] && currentStep > getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') && currentStep < getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')))
                      )">
                        <Person v-show="!(i === 0 && ([weeklywrkplcinspctsteps[0], prsnlAppntmntsteps[0]].includes(selectedActvt)))" type="memberActive" size="small1"
                          :class="[
                            { 'icon-fade-out': selectedActvt === commttMtgsteps[0] && currentStep === getActyStepIndex(commttMtgsteps[1], 'AnimateMtg')},
                            { 'icon-fade-in': (
                              (selectedActvt === setupsteps[0] && currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < setupsteps[1].length - 1) ||
                              (selectedActvt === commttMtgsteps[0] && currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < commttMtgsteps[1].length - 1)
                            )}
                          ]"
                          :style="[
                            [ (
                                (selectedActvt === setupsteps[0] && currentStep <= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < setupsteps[1].length - 1) ||
                                (selectedActvt === commttMtgsteps[0] && currentStep < commttMtgsteps[1].length - 1) && 
                                [getActyStepIndex(commttMtgsteps[1], 'AnimateMtg'),getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')].includes(currentStep) 
                              ) 
                              ? 'opacity: 0;' : ''],
                            [ selectedActvt === commttMtgsteps[0] && currentStep === getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimateMtg')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimateMtg').delay}s;` : '' ],
                            [ selectedActvt === setupsteps[0] && currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(setupsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(setupsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ],
                            [ selectedActvt === commttMtgsteps[0] && currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ]
                          ]"
                        />
                      </template>
                    </foreignObject>
                  </g>
                  <g :class="{ inactivemember : nbEmplyRepresentative <= 0 }">
                    <text x="38" y="476" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("TOTALREQ.EMPLOYEEREPRESENTATIVE1")}}</text>
                    <rect x="36" y="480" class="team-member-box"/>
                    <foreignObject v-for="(n,i) in nbEmplyRepresentative" :key="n.id" :x="42 + i*16" y="484" class="icon-member">
                      <template v-if="!(
                        ((selectedActvt === setupsteps[0] && currentStep < getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam')) ||
                        (selectedActvt === commttMtgsteps[0] && currentStep > getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') && currentStep < getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')))
                      )">
                        <Person type="memberActive" size="small1"
                          :class="[
                            { 'icon-fade-out': selectedActvt === commttMtgsteps[0] && currentStep === getActyStepIndex(commttMtgsteps[1], 'AnimateMtg')},
                            { 'icon-fade-in': (
                              (selectedActvt === setupsteps[0] && currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < setupsteps[1].length - 1) ||
                              (selectedActvt === commttMtgsteps[0] && currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < commttMtgsteps[1].length - 1)
                            )}
                          ]"
                          :style="[
                            [ (
                                (selectedActvt === setupsteps[0] && currentStep <= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') && currentStep < setupsteps[1].length - 1) ||
                                (selectedActvt === commttMtgsteps[0] && currentStep < commttMtgsteps[1].length - 1) && 
                                [getActyStepIndex(commttMtgsteps[1], 'AnimateMtg'),getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')].includes(currentStep) 
                              ) 
                              ? 'opacity: 0;' : ''],
                            [ selectedActvt === commttMtgsteps[0] && currentStep === getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimateMtg')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimateMtg').delay}s;` : '' ],
                            [ selectedActvt === setupsteps[0] && currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(setupsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(setupsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ],
                            [ selectedActvt === commttMtgsteps[0] && currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ]
                          ]"
                        />
                      </template>
                    </foreignObject>
                  </g>
                </g>
                <g transform="translate(410, 182)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('team-title') }"
                    @mouseenter="showTooltipByOpt($event, false, true, 0, -550, 643)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, -550, $t('DIAGRAM.TEAMTITLE'), 'team-title', $t('TOOLTIP.HEALTH&SAFETYTEAM'), 643)"
                    :data-tooltipHeader = "$t('DIAGRAM.TEAMTITLE')"
                    :data-tooltipContent = "$t('TOOLTIP.HEALTH&SAFETYTEAM')"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </g>

              <!-- ARROWS ABOVE TEAM -->
              <!--Health Committee Setup Arrow Above team-->
              <template v-if="selectedActvt == setupsteps[0] && actyDisplayCondition(setupsteps[0])">
                <!--Team to Records-->
                <g v-if="currentStep >= getActyStepIndex(setupsteps[1], 'ReportTeamtoRecords')" 
                  class="fade-in"
                  :style="`stroke-dasharray: 329; stroke-dashoffset: 329; animation-duration:${ getArrowPathDuration(329, 580, 532, setupsteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${ getActyStepByStepNm(setupsteps[1], 'ReportTeamtoRecords').delay }s;`"
                >
                  <path class="arrowtan shadow-line-curve-down show-arrow-head" d="M 362 376 V480 C 362 558, 370 558, 532 558"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(329, 580, 532, setupsteps[1], 'ReportTeamtoRecords') - 0.25 + getActyStepByStepNm(setupsteps[1], 'ReportTeamtoRecords').delay}s;`" 
                  />
                  <text x="540" y="564" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(setupsteps[1], 'ReportTeamtoRecords')}"
                    :style="[ (currentStep >= getActyStepIndex(setupsteps[1], 'ReportTeamtoRecords')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(329, 580, 532, setupsteps[1], 'ReportTeamtoRecords') - 0.1 + getActyStepByStepNm(setupsteps[1], 'ReportTeamtoRecords').delay }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoRecords') }}
                  </text>
                </g>
              </template>

              <!--Health Check Arrow Above Team box-->
              <template v-if="selectedActvt == healthChecksteps[0]">
                <!--Team to Records-->
                <g v-if="needsIndusPhysician &&
                        (currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoRecords'))"
                  class="fade-in"
                  :style="`stroke-dasharray: 340; stroke-dashoffset: 340; animation-duration:${ getArrowPathDuration(296, 580, 532, healthChecksteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoRecords').delay}s;`"
                >
                  <path class="arrowtan shadow-line-curve-down show-arrow-head" d="M 347 376 V480 C 347 558, 370 558, 532 558"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(296, 580, 532, healthChecksteps[1], 'ReportTeamtoRecords') - 0.25 + getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoRecords').delay}s;`"  
                  />
                  <text x="540" y="563" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoRecords')}"
                    :style="[ (currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoRecords')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(296, 580, 532, healthChecksteps[1], 'ReportTeamtoRecords') - 0.1 + getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoRecords').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoRecords')  }}
                  </text>
                </g>
                <!--Team to LSO-->
                <g v-if="needsIndusPhysician && currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoLSO')"
                  class="fade-in"
                  :style="`stroke-dasharray: 874; stroke-dashoffset: 874; animation-duration:${ getArrowPathDuration(874, 1152, 1104, healthChecksteps[1], 'ReportTeamtoLSO') }s; animation-delay: ${getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoLSO').delay}s;`"
                >
                  <path class="arrowtan shadow-line-curve-up show-arrow-head" d="M 397 358 V234 C 397 142, 480 142, 1104 142"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(928, 1152, 1104, healthChecksteps[1], 'ReportTeamtoLSO') - 0.25 + getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoLSO').delay}s;`"
                  />           
                  <text x="1110" y="147" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoLSO')}"
                    :style="[ (currentStep >= getActyStepIndex(healthChecksteps[1],'ReportTeamtoLSO')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(928, 1152, 1104, healthChecksteps[1], 'ReportTeamtoLSO') - 0.1 + getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoLSO').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoLSO') }}
                  </text>
                </g>
              </template>

              <!--Stress Check Arrow Above Team box-->
              <template v-if="selectedActvt === stressChecksteps[0] && actyDisplayCondition(stressChecksteps[0])">
                <!--Team to LSO-->
                <g v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'ReportTeamtoLSO')"
                  class="fade-in"
                  :style="`stroke-dasharray: 956; stroke-dashoffset: 956; animation-duration:${ getArrowPathDuration(956, 1152, 1104, stressChecksteps[1], 'ReportTeamtoLSO') }s; animation-delay: ${getActyStepByStepNm(stressChecksteps[1], 'ReportTeamtoLSO').delay}s;`"
                >
                  <path class="arrowtan shadow-line-curve-up show-arrow-head" d="M 361 406 V232 C 361 142, 480 142, 1104 142"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(956, 1152, 1104, stressChecksteps[1], 'ReportTeamtoLSO') - 0.25 + getActyStepByStepNm(stressChecksteps[1], 'ReportTeamtoLSO').delay}s;`"
                  />
                  <text x="1110" y="147" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= (stressChecksteps[1].indexOf('ReportTeamtoLSO') - 1)}"
                    :style="[ (currentStep >= getActyStepIndex(stressChecksteps[1],'ReportTeamtoLSO')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(956, 1152, 1104, stressChecksteps[1], 'ReportTeamtoLSO') - 0.1 + getActyStepByStepNm(stressChecksteps[1], 'ReportTeamtoLSO').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoLSO') }}
                  </text>
                </g>
              </template>

              <!--Monthly Workplace Inspection Arrow Above Team box-->
              <template v-if="selectedActvt == mnthlywrkplcinspctsteps[0] && actyDisplayCondition(mnthlywrkplcinspctsteps[0])">
                <!--Team to Records-->
                <g v-if="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords')" 
                  class="fade-in"
                  :style="`stroke-dasharray: 329; stroke-dashoffset: 329; animation-duration:${ getArrowPathDuration(329, 580, 532, mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${ getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords').delay }s;`"
                >
                  <path class="arrowtan shadow-line-curve-down show-arrow-head" d="M 362 376 V480 C 362 558, 370 558, 532 558"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(329, 580, 532, mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords') - 0.25 + getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords').delay}s;`" 
                  />
                  <text x="540" y="564" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords')}"
                    :style="[ (currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords')) ? `animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(329, 580, 532, mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords') - 0.1 + getActyStepByStepNm(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords').delay }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoRecords') }}
                  </text>
                </g>
              </template>

              <!--Weekly Workplace Inspection Arrow Above Team box-->
              <template v-if="selectedActvt == weeklywrkplcinspctsteps[0] && actyDisplayCondition(weeklywrkplcinspctsteps[0])">
                <!--Team to Records-->
                <g v-if="currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords')" 
                  class="fade-in"
                  :style="`stroke-dasharray: 329; stroke-dashoffset: 329; animation-duration:${ getArrowPathDuration(329, 580, 532, weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${ getActyStepByStepNm(weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords').delay }s;`"
                >
                  <path class="arrowtan shadow-line-curve-down show-arrow-head" d="M 362 376 V480 C 362 558, 370 558, 532 558"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(329, 580, 532, weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords') - 0.25 + getActyStepByStepNm(weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords').delay}s;`" 
                  />
                  <text x="540" y="564" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords')}"
                    :style="[ (currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords')) ? `animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(329, 580, 532, weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords') - 0.1 + getActyStepByStepNm(weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords').delay }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoRecords') }}
                  </text>
                </g>
              </template>

              <!--Health Committee Setup Arrow Above team-->
              <template v-if="selectedActvt == commttMtgsteps[0] && actyDisplayCondition(setupsteps[0])">
                <!--Team to Records-->
                <g v-if="currentStep >= getActyStepIndex(commttMtgsteps[1], 'ReportTeamtoRecords')" 
                  class="fade-in"
                  :style="`stroke-dasharray: 328; stroke-dashoffset: 328; animation-duration:${ getArrowPathDuration(328, 580, 532, commttMtgsteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1], 'ReportTeamtoRecords').delay }s;`"
                >
                  <path class="arrowtan shadow-line-curve-down show-arrow-head" d="M 362 376 V480 C 362 558, 370 558, 532 558"
                    :style="`animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(328, 580, 532, commttMtgsteps[1], 'ReportTeamtoRecords') - 0.25 + getActyStepByStepNm(commttMtgsteps[1], 'ReportTeamtoRecords').delay}s;`" 
                  />
                  <text x="540" y="564" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(commttMtgsteps[1], 'ReportTeamtoRecords')}"
                    :style="[ (currentStep >= getActyStepIndex(commttMtgsteps[1], 'ReportTeamtoRecords')) ? `animation-duration: 0.25s; animation-delay: ${  getArrowPathDuration(328, 580, 532, commttMtgsteps[1], 'ReportTeamtoRecords') - 0.1 + getActyStepByStepNm(commttMtgsteps[1], 'ReportTeamtoRecords').delay }s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoRecords') }}
                  </text>
                </g>
              </template>

              <!-- Personnel Appointment Arrow -->
              <template v-if="selectedActvt === prsnlAppntmntsteps[0] && actyDisplayCondition(prsnlAppntmntsteps[0])">
                <!--Team to LSO-->
                <g v-if="currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'ReportTeamtoLSO')"
                  class="fade-in"
                  :style="`stroke-dasharray: 956; stroke-dashoffset: 956; animation-duration:${ getArrowPathDuration(956, 1152, 1104, prsnlAppntmntsteps[1], 'ReportTeamtoLSO') }s; animation-delay: ${getActyStepByStepNm(prsnlAppntmntsteps[1], 'ReportTeamtoLSO').delay}s;`"
                >
                  <path class="arrowtan shadow-line-curve-up show-arrow-head" d="M 361 406 V232 C 361 142, 480 142, 1104 142"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(956, 1152, 1104, prsnlAppntmntsteps[1], 'ReportTeamtoLSO') - 0.25 + getActyStepByStepNm(prsnlAppntmntsteps[1], 'ReportTeamtoLSO').delay}s;`"
                  />
                  <text x="1110" y="148" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= (prsnlAppntmntsteps[1].indexOf('ReportTeamtoLSO') - 1)}"
                    :style="[ (currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'ReportTeamtoLSO')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(956, 1152, 1104, prsnlAppntmntsteps[1], 'ReportTeamtoLSO') - 0.1 + getActyStepByStepNm(prsnlAppntmntsteps[1], 'ReportTeamtoLSO').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoLSO') }}
                  </text>
                </g>
              </template>

              <!-- Incident Reporting Arrow Above Team -->
              <template v-if="selectedActvt === incdntRprtngsteps[0]">
                <!--Team to LSO-->
                <g v-if="currentStep >= getActyStepIndex(incdntRprtngsteps[1],'ReportTeamtoLSO')"
                  class="fade-in"
                  :style="`stroke-dasharray: 956; stroke-dashoffset: 956; animation-duration:${ getArrowPathDuration(956, 1152, 1104, incdntRprtngsteps[1], 'ReportTeamtoLSO') }s; animation-delay: ${getActyStepByStepNm(incdntRprtngsteps[1], 'ReportTeamtoLSO').delay}s;`"
                >
                  <path class="arrowtan shadow-line-curve-up show-arrow-head" d="M 361 406 V232 C 361 142, 480 142, 1104 142"
                    :style="`animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(956, 1152, 1104, incdntRprtngsteps[1], 'ReportTeamtoLSO') - 0.25 + getActyStepByStepNm(incdntRprtngsteps[1], 'ReportTeamtoLSO').delay}s;`"
                  />
                  <text x="1110" y="148" class="step-number"
                    :class="{ 'icon-fade-in': currentStep >= (incdntRprtngsteps[1].indexOf('ReportTeamtoLSO') - 1)}"
                    :style="[ (currentStep >= getActyStepIndex(incdntRprtngsteps[1],'ReportTeamtoLSO')) ? `animation-duration: 0.25s; animation-delay: ${ getArrowPathDuration(956, 1152, 1104, incdntRprtngsteps[1], 'ReportTeamtoLSO') - 0.1 + getActyStepByStepNm(incdntRprtngsteps[1], 'ReportTeamtoLSO').delay}s; opacity: 0;` : '']"
                  >
                    {{ selectedActyStepsNoEmpty.indexOf('ReportTeamtoLSO') }}
                  </text>
                </g>
              </template>

              <!--LSO to Company Default-->
              <line stroke="#C4BD97" stroke-width="26" x1="1144" y1="56" x2="886" y2="56" marker-end="url(#arrowheadDark)" class="shadow-line"/>
              <text x="886" y="61" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.REGULATION")}}</text>
              <!--Labor Standards Office-->
              <g id="LSO">
                <rect x="1144" y="20" rx="24" class="border-box external-box shadow-block"/>
                <g transform="translate(40 0)">
                  <text :x="i18n.locale.value === 'en-US' ? 1181 : 1176" y="85" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.LSO1")}}</text>
                  <text :x="i18n.locale.value === 'en-US' ? 1165 : 1149" y="104" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.LSO2")}}</text>
                  <text x="1180" y="124" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.LSO3")}}</text>
                </g>
                <g transform="translate(1318, -240)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('lso') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -186, -146)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -186, -146, $t('TOTALREQ.LSO'), 'lso', $t('TOOLTIP.' + getTooltipContent('LSO')))"
                    :data-tooltipHeader = "$t('TOTALREQ.LSO')"
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('LSO'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </g>

              <!--Records-->
              <g transform="translate(-76 106)">
                <rect x="650" y="410" width="144" height="104" rx="10" class="border-box comp-object-box shadow-block"/>
                <text :x="i18n.locale.value === 'en-US' ? 718 : 704" y="448" class="memberboxtitle-large" :class="{'text-locale-jp3': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.RECORD1")}}</text>
                <text :x="i18n.locale.value === 'en-US' ? 715 : 710" y="466" class="memberboxtitle-large" :class="{'text-locale-jp3': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.RECORD2")}}</text>
                <text :x="i18n.locale.value === 'en-US' ? 715 : 710" y="458" class="memberboxtitle-large" :class="{'text-locale-jp3': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.RECORD3")}}</text>
                <g transform="translate(820, 70)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                  :class="{ 'tooltip-active': keepTooltipsIds.includes('safebox') }"
                  @mouseenter="showTooltipByOpt($event, false, true, 0, -66)"
                  @mouseleave="closeTooltip()"
                  @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, -66, $t('TOTALREQ.SECURESTORAGE'), 'safebox', $t('TOOLTIP.' + getTooltipContent('safeBox')))"
                  :data-tooltipHeader = "$t('TOTALREQ.SECURESTORAGE')"
                  :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('safeBox'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </g>

              <!--Industrial Physician-->
              <transition name="fade">
                <g id="indusPhysician" :class="{ inactivemember : !needsIndusPhysician }" transform="translate(48 20)">
                  <rect x="1144" y="250" rx="18" class="border-box external-box shadow-block"/>
                  <text :x="i18n.locale.value === 'en-US' ? 1156 : 1174" y="275" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.INDUSPHYSICIAN1")}}</text>
                  <text x="1158" y="293" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.INDUSPHYSICIAN2")}}</text>
                  <text x="1171" y="285" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.INDUSPHYSICIAN3")}}</text>
                  <g transform="translate(1228, -6)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('physician') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -106, -150)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -106, -150, $t('TOTALREQ.PHYSICIAN'), 'physician', $t('TOOLTIP.' + getTooltipContent('indusPhysician')))"
                      :data-tooltipHeader = "$t('TOTALREQ.PHYSICIAN')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('indusPhysician'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                </g>
              </transition>

              <!--Health Clinic-->
              <g id="healthClinic" transform="translate(0 10)">
                <rect x="1144" y="626" rx="24" class="border-box external-box shadow-block"/>
                <g transform="translate(36 40)">
                  <text :x="i18n.locale.value === 'en-US' ? 1182 : 1174" y="668" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.HEALTHCLINIC1")}}</text>
                  <text x="1185" y="688" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.HEALTHCLINIC2")}}</text>
                  <text x="1169" y="678" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.HEALTHCLINIC3")}}</text>
                  <g transform="translate(1284, 325)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('hlthClinic') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -186, -144)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -186, -144, $t('TOTALREQ.HEALTHCLINIC'), 'hlthClinic', $t('TOOLTIP.' + getTooltipContent('hlthClinic')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HEALTHCLINIC')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('hlthClinic'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                </g>
              </g>

              <!--Workplace, Facilities-->
              <g transform="translate(-76 0)">
                <rect x="650" y="220" width="144" height="104" rx="10" class="border-box comp-object-box shadow-block"/>
                <text :x="i18n.locale.value === 'en-US' ? 705 : 730" y="267" class="memberboxtitle-large" :class="{'text-locale-jp': i18n.locale.value === 'ja-JP'}">{{$t("DIAGRAM.WORKPLACE")}}</text>
              </g>

              <!-- ACTIVITIES ICON -->
              <!-- Health Committee Setup Icon -->
              <template v-if="selectedActvt == setupsteps[0] && actyDisplayCondition(setupsteps[0])">
                <!-- Personnel -->
                <g v-if="currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinOutTeam') && currentStep < setupsteps[1].length - 1" class="personnel-row">
                  <foreignObject v-for="i in neededNoOfPersonnel" :key="i" 
                    :x="318 + ((i - 1) % 6)*16"
                    :y="(i - 1) < 6 ? 310 : 250"
                    class="icon-member"
                  >
                    <Person type="memberActive" size="small1"
                      :class="[
                        { 'icon-fade-in': currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinOutTeam') },
                        { 'icon-fade-out': currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') }
                      ]"
                      :style="[
                        [ currentStep <= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinOutTeam') ? 'opacity: 0;' : ''],
                        [ currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinOutTeam') ? `animation-duration: 0.5s; animation-delay: ${(i-1)*0.11}s;` : '' ],
                        [ currentStep >= getActyStepIndex(setupsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(setupsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(setupsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ],
                      ]"
                    />
                  </foreignObject>
                </g>
                <!-- Report -->
                <g>
                  <rect width="54" height="50" x="338" y="376" fill="#C4BD97"/>
                  <foreignObject v-if="currentStep >= getActyStepIndex(setupsteps[1], 'ReportTeamtoRecords')"
                    x="338" y="376" width="54" height="50" class="prev-report"
                  >
                    <Person class="report" type="report2" size="medium3"/>
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(378, 8)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HEALTHCOMMITTEEPOLICY') }"
                      @mouseenter="showTooltipByOpt($event, false, true, 0, -40)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, -40, $t('TOTALREQ.HEALTHCOMMITTEEPOLICY'), 'HEALTHCOMMITTEEPOLICY' , $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HEALTHCOMMITTEEPOLICY')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                  <foreignObject v-if="currentStep >= getActyStepIndex(setupsteps[1], 'AnimateTeamgenerateReporttoRecords')" width="54" height="50" x="338" y="376" 
                    :class="[
                      {'icon-fade-in': currentStep >= getActyStepIndex(setupsteps[1], 'AnimateTeamgenerateReporttoRecords') },
                      {'animate-team-to-records': currentStep >= getActyStepIndex(setupsteps[1],'ReportTeamtoRecords')}
                    ]"
                    :style="[
                      [ currentStep >= getActyStepIndex(setupsteps[1],'AnimateTeamgenerateReporttoRecords') ? `animation-duration:${getActyStepDuration(setupsteps[1], 'AnimateTeamgenerateReporttoRecords')}s; animation-delay: ${ getActyStepByStepNm(setupsteps[1],'AnimateTeamgenerateReporttoRecords').delay}s;` : '' ],
                      [ currentStep >= getActyStepIndex(setupsteps[1], 'ReportTeamtoRecords') ? `animation-duration:${getActyStepDuration(setupsteps[1], 'ReportTeamtoRecords')}s; animation-delay: ${ getActyStepByStepNm(setupsteps[1],'ReportTeamtoRecords').delay}s;` : '' ],
                    ]"
                  >
                    <Person class="report" type="report3" size="medium3"
                      :growReport="currentStep >= getActyStepIndex(setupsteps[1], 'AnimateTeamgenerateReporttoRecords')"
                      :duration="getActyStepDuration(setupsteps[1], 'AnimateTeamgenerateReporttoRecords')"
                    />
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(618, 169)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HEALTHCOMMITTEEPOLICY') }"
                      @mouseenter="showTooltipByOpt($event, false, true, 0, -44)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, -44, $t('TOTALREQ.HEALTHCOMMITTEEPOLICY'), 'HEALTHCOMMITTEEPOLICY' , $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HEALTHCOMMITTEEPOLICY')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                </g>
              </template>

              <!-- Health Check Icon -->
              <template v-if="selectedActvt == healthChecksteps[0]">
                <!-- Clinic to Regular Employees Health Check Result Icon-->
                <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateReportClinictoEmp')"
                  x="1230" y="666" width="34" height="30" class="prev-report"
                >
                  <Person class="report" type="report" size="smallWide2"/>
                </foreignObject>
                <g v-if="(needsIndusPhysician && currentStep === selectedActySteps[1].length - 1) || (!needsIndusPhysician && currentStep === getActyStepIndex(healthCheckstepsNoPhysician[1], 'AnimateEnd'))" transform="translate(1252, 282)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('HEALTHCHECKRESULTS') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -24)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -24, $t('TOTALREQ.HEALTHCHECKRESULTS'), 'HEALTHCHECKRESULTS', $t('TOOLTIP.' + getTooltipContent('ReportClinictoEmp')))"
                    :data-tooltipHeader = "$t('TOTALREQ.HEALTHCHECKRESULTS')"
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportClinictoEmp'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateClinicgenerateReporttoEmp')"
                  x="348" y="666" width="34" height="30"
                  :class="[
                    { 'health-result-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateClinicgenerateReporttoEmp') },
                    { 'animate-report-clinic-to-emp': currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateReportClinictoEmp') }
                  ]"  
                  :style="[
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateClinicgenerateReporttoEmp') ? `animation-duration:${getActyStepDuration(healthChecksteps[1], 'AnimateClinicgenerateReporttoEmp')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1],'AnimateClinicgenerateReporttoEmp').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateReportClinictoEmp') ? `animation-duration:${getActyStepDuration(healthChecksteps[1], 'AnimateReportClinictoEmp')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1],'AnimateReportClinictoEmp').delay}s;` : '' ],
                  ]"
                >
                  <Person class="report" type="report" size="smallWide2"
                    :growReport="currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateClinicgenerateReporttoEmp')"
                    :duration="getActyStepDuration(healthChecksteps[1], 'AnimateClinicgenerateReporttoEmp')"
                  />
                </foreignObject>
                <g v-if="(needsIndusPhysician && currentStep === selectedActySteps[1].length - 1) || (!needsIndusPhysician && currentStep === getActyStepIndex(healthCheckstepsNoPhysician[1], 'AnimateEnd'))" transform="translate(290, 312)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('HEALTHCHECKRESULTS') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -40, -24)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -40, -24, $t('TOTALREQ.HEALTHCHECKRESULTS'), 'HEALTHCHECKRESULTS', $t('TOOLTIP.' + getTooltipContent('ReportClinictoEmp')))"
                    :data-tooltipHeader = "$t('TOTALREQ.HEALTHCHECKRESULTS')"
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportClinictoEmp'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                
                <!--Regular Employees Icon-->
                <template v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmpfadein')">
                  <foreignObject v-if="currentStep <= getActyStepIndex(healthChecksteps[1],'AnimateEmpturnBlue')" width="16" height="50" x="262" y="696">
                    <Person type="memberInactive" size="small1"/>
                  </foreignObject>
                </template>
                <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmpturnBlue')" width="16" height="50" x="262" y="696"
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmpturnBlue')},
                    {'emp-to-comp-edge': currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptoCompEdge')},
                    {'emp-comp-to-clinic': currentStep >= getActyStepIndex(healthChecksteps[1],'EmptoClinic')},
                    {'emp-take-healthcheck-blink': currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptakeHealthCheckBlink')},
                    {'emp-take-healthcheck-move': currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptakeHealthCheckMove')},
                    {'emp-clinic-to-comp': currentStep >= getActyStepIndex(healthChecksteps[1],'EmpClinictoComp')},
                    {'emp-to-comp-center': currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptoCompCenter')},
                  ]"
                  :style="[
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmpturnBlue') ? `animation-duration:${getActyStepDuration(healthChecksteps[1], 'AnimateEmpturnBlue')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1],'AnimateEmpturnBlue').delay}s; opacity: 0;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptoCompEdge') ? `transition-duration:${getActyStepDuration(healthChecksteps[1], 'AnimateEmptoCompEdge')}s; transition-delay: ${ getActyStepByStepNm(healthChecksteps[1],'AnimateEmptoCompEdge').delay}s; opacity: 1;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'EmptoClinic') ? `transition-duration:${getActyStepDuration(healthChecksteps[1], 'EmptoClinic')}s; transition-delay: ${ getActyStepByStepNm(healthChecksteps[1],'EmptoClinic').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptakeHealthCheckBlink') ? `animation-duration: ${getActyStepDuration(healthChecksteps[1], 'AnimateEmptakeHealthCheckBlink')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1],'AnimateEmptakeHealthCheckBlink').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptakeHealthCheckMove') ? `animation-duration: ${getActyStepDuration(healthChecksteps[1], 'AnimateEmptakeHealthCheckMove')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1],'AnimateEmptakeHealthCheckMove').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'EmpClinictoComp') ? `transition-duration:${getActyStepDuration(healthChecksteps[1], 'EmpClinictoComp')}s; transition-delay: ${ getActyStepByStepNm(healthChecksteps[1],'EmpClinictoComp').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateEmptoCompCenter') ? `transition-duration:${getActyStepDuration(healthChecksteps[1], 'AnimateEmptoCompCenter')}s; transition-delay: ${ getActyStepByStepNm(healthChecksteps[1],'AnimateEmptoCompCenter').delay}s;` : '' ],
                  ]"
                >
                  <Person type="memberActive" size="small1"/>
                </foreignObject>

                <!-- Clinic to Industrial Physician Health Check Result Icon -->
                <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'ReportIndusPhysiciantoRecords') && needsIndusPhysician" x="1230" y="390" width="34" height="30" class="prev-report">
                  <Person class="report" type="report" size="smallWide2"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1 && needsIndusPhysician" transform="translate(1252, 6)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('HEALTHCHECKRESULTS') }"
                     @mouseenter="showTooltipByOpt($event, true, true, -44, -24)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -24, $t('TOTALREQ.HEALTHCHECKRESULTS'), 'HEALTHCHECKRESULTS', $t('TOOLTIP.' + getTooltipContent('ReportClinictoEmp')))"
                    :data-tooltipHeader = "$t('TOTALREQ.HEALTHCHECKRESULTS')"
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportClinictoIndusPhysician'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateClinicgenerateReporttoIndusPhysician') && needsIndusPhysician" x="1230" y="390" width="34" height="30"
                  :class="[
                    { 'animate-report-clinic-to-physician-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician')},
                    { 'animate-report-clinic-to-physician': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportClinictoIndusPhysician')},
                    { 'animate-report-physician-to-records': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoRecords')},
                  ]"
                  :style="[
                    [ currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician') ? `animation-duration:${getActyStepDuration(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician')}s;` : '' ],
                    [ currentStep >= (healthChecksteps[1].indexOf('ReportClinictoIndusPhysician')) ? `transition-duration:${ getActyStepDuration(healthChecksteps[1], 'ReportClinictoIndusPhysician')}s;` : '' ],
                    [ currentStep >= getActyStepIndex(healthChecksteps[1],'ReportIndusPhysiciantoRecords') ? `animation-duration:${getActyStepDuration(healthChecksteps[1], 'ReportIndusPhysiciantoRecords')}s; animation-delay: ${getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoRecords').delay}s;` : '' ],
                  ]"                   
                >
                  <Person class="report" type="report" size="smallWide2"
                    :growReport="currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician')"
                    :duration="getActyStepDuration(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1 && needsIndusPhysician" transform="translate(738, 156)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('HEALTHCHECKRESULTS') }"
                     @mouseenter="showTooltipByOpt($event, true, true, -44, -24)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -24, $t('TOTALREQ.HEALTHCHECKRESULTS'), 'HEALTHCHECKRESULTS', $t('TOOLTIP.' + getTooltipContent('ReportClinictoEmp')))"
                    :data-tooltipHeader = "$t('TOTALREQ.HEALTHCHECKRESULTS')"
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportClinictoIndusPhysician'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>

                <!--Health Check Evaluate & Summary Reports Icon-->
                <g v-if="needsIndusPhysician && currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateIndusPhysiciangenerateReporttoTeam')">
                  <!-- Summary report to LSO -->
                  <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoTeam')" width="54" height="50" x="1244" y="328" class="prev-report">
                    <Person class="report" type="report2" size="medium3"/>
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1276, -36)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HLTHSUMMARYREPORT') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.HLTHSUMMARYREPORT'), 'HLTHSUMMARYREPORT', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HLTHSUMMARYREPORT')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                  <rect width="48" height="50" x="372" y="328" fill="#C4BD97"/>
                  <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoLSO')" width="54" height="50" x="372" y="328" class="prev-report">
                    <Person class="report" type="report2" size="medium3"/>
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(410, -36)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HLTHSUMMARYREPORT') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.HLTHSUMMARYREPORT'), 'HLTHSUMMARYREPORT', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HLTHSUMMARYREPORT')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                  <foreignObject width="54" height="50" x="1244" y="328"
                    :class="[
                      {'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateIndusPhysiciangenerateReporttoTeam')},
                      {'animate-report-physician-to-team-healthcheck': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoTeam') },
                      {'animate-team-to-lso-healthcheck': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoLSO') },
                    ]"
                    :style="[
                      `animation-duration: ${getActyStepDuration(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician').delay }s;`,
                      [ currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoTeam') ? `transition-duration:${getActyStepDuration(healthChecksteps[1], 'ReportIndusPhysiciantoTeam')}s; transition-delay: ${getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoTeam').delay}s;` : '' ],
                      [ currentStep >= getActyStepIndex(healthChecksteps[1],'ReportTeamtoLSO') ? `animation-duration:${getActyStepDuration(healthChecksteps[1], 'ReportTeamtoLSO')}s; animation-delay: ${getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoLSO').delay}s;` : '' ],
                    ]"
                  >
                    <Person class="report" type="report2" size="medium3"
                      :growReport="currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateIndusPhysiciangenerateReporttoTeam')"
                      :duration="getActyStepDuration(healthChecksteps[1], 'AnimateIndusPhysiciangenerateReporttoTeam')"
                    />
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1188, -248)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HLTHSUMMARYREPORT') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.HLTHSUMMARYREPORT'), 'HLTHSUMMARYREPORT', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HLTHSUMMARYREPORT')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                  <!-- Evaluation report to records -->
                  <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'ReportIndusPhysiciantoTeam')" width="54" height="50" x="1194" y="328" class="prev-report">
                    <Person class="report" type="report3" size="medium3"/>
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1228, -36)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HLTHEVALUATEREPORT') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.HLTHEVALUATEREPORT'), 'HLTHEVALUATEREPORT', $t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HLTHEVALUATEREPORT')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                  <rect width="50" height="50" x="322" y="328" fill="#C4BD97"/> 
                  <foreignObject v-if="currentStep >= getActyStepIndex(healthChecksteps[1],'ReportTeamtoRecords')" width="54" height="50" x="322" y="328" class="prev-report">
                    <Person class="report" type="report3" size="medium3"/>
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(358, -36)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HLTHEVALUATEREPORT') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.HLTHEVALUATEREPORT'), 'HLTHEVALUATEREPORT', $t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HLTHEVALUATEREPORT')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                  <foreignObject width="54" height="50" x="1194" y="328"
                    :class="[
                      {'icon-fade-in': currentStep >= getActyStepIndex(healthChecksteps[1],'AnimateIndusPhysiciangenerateReporttoTeam')},
                      {'animate-report-physician-to-team-healthcheck': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportIndusPhysiciantoTeam') },
                      {'animate-team-to-records-evaluate': currentStep >= getActyStepIndex(healthChecksteps[1], 'ReportTeamtoRecords') },
                    ]"
                    :style="[
                      `animation-duration: ${getActyStepDuration(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1], 'AnimateClinicgenerateReporttoIndusPhysician').delay }s;`,
                      [ currentStep >= getActyStepIndex(healthChecksteps[1],'ReportIndusPhysiciantoTeam') ? `transition-duration:${getActyStepDuration(healthChecksteps[1], 'ReportIndusPhysiciantoTeam')}s; transition-delay: ${getActyStepByStepNm(healthChecksteps[1], 'ReportIndusPhysiciantoTeam').delay}s;` : '' ],
                      [ currentStep >= getActyStepIndex(healthChecksteps[1],'ReportTeamtoRecords') ? `animation-duration:${getActyStepDuration(healthChecksteps[1], 'ReportTeamtoRecords')}s; animation-delay: ${ getActyStepByStepNm(healthChecksteps[1], 'ReportTeamtoRecords').delay}s;` : '' ],
                    ]"
                  >
                    <Person class="report" type="report3" size="medium3"
                      :growReport="currentStep >= getActyStepIndex(healthChecksteps[1], 'AnimateIndusPhysiciangenerateReporttoTeam')"
                      :duration="getActyStepDuration(healthChecksteps[1], 'AnimateIndusPhysiciangenerateReporttoTeam')"
                    />
                  </foreignObject>
                  <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(618, 169)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                      :class="{ 'tooltip-active': keepTooltipsIds.includes('HLTHEVALUATEREPORT') }"
                      @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                      @mouseleave="closeTooltip()"
                      @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.HLTHEVALUATEREPORT'), 'HLTHEVALUATEREPORT', $t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam')))"
                      :data-tooltipHeader = "$t('TOTALREQ.HLTHEVALUATEREPORT')"
                      :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam'))"
                    >
                      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                      <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                  </g>
                </g>
              </template>

              <!-- Stress Check Icon -->
              <template v-if="selectedActvt == stressChecksteps[0] && currentStep >= 0 && actyDisplayCondition(stressChecksteps[0])">
                <!-- Laptop icon -->
                <foreignObject width="100" height="100" x="620" y="670" class="icon-fade-in"
                  :style="`animation-duration:${getActyStepDuration(stressChecksteps[1], 'AnimateEmpturnBlue')}s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1],'AnimateEmpturnBlue').delay}s;`"
                >
                  <Person type="laptop" size="large5"/>
                </foreignObject>

                <!-- Stress Check Test -->
                <rect v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp')" x="702" y="732" class="background-white report-background-small"/>
                <polygon transform="translate(0 10)" points="718,721 726,721 726,729" class="background-green"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateEmpgenerateReport')" width="34" height="30" x="270" y="732" 
                  :class="[
                    { 'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateEmpgenerateReport')},
                    {'animate-report-emp-to-laptop': currentStep >= getActyStepIndex(stressChecksteps[1],'ReportEmptoLaptop') },
                    {'icon-fade-out-half': currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp') },
                  ]"
                  :style="[
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateEmpgenerateReport') ? `animation-duration:${getActyStepDuration(stressChecksteps[1], 'AnimateEmpgenerateReport')}s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1],'AnimateEmpgenerateReport').delay}s; opacity: 0;` : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'ReportEmptoLaptop') ? `transition-duration:${getActyStepDuration(stressChecksteps[1], 'ReportEmptoLaptop')}s; transition-delay: ${ getActyStepByStepNm(stressChecksteps[1],'ReportEmptoLaptop').delay}s; opacity: 1;` : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1], 'AnimateLaptopgenerateReporttoEmp') ? `animation-duration:${getActyStepDuration(stressChecksteps[1], 'AnimateLaptopgenerateReporttoEmp')}s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp').delay}s;` : '' ],
                  ]"
                >
                  <Person class="report" type="report3" size="smallWide2"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(718, 348)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('laptop-STRESSCHECK') }"
                    @mouseenter="showTooltipByOpt($event, false, true, 0, i18n.locale.value === 'en-US' ? -54 : -76)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, i18n.locale.value === 'en-US' ? -54 : -76, $t('TOTALREQ.STRESSCHECK'), 'laptop-STRESSCHECK', $t('TOOLTIP.' + getTooltipContent('ReportEmptoLaptop')))"
                    :data-tooltipHeader = "$t('TOTALREQ.STRESSCHECK')"
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportEmptoLaptop'))"                  
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>

                <!-- Stress Check Result to Emp -->
                <rect v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoEmp')" x="703" y="684" class="background-blue report-background-small"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportLaptoptoEmp')"
                  width="54" height="50" x="700" y="684" class="prev-report"
                >
                  <Person class="report" type="report2" size="smallWide2"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(718, 302)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('STRESSCHECKRESULT') }"
                    @mouseenter="showTooltipByOpt($event, false, true, 0, i18n.locale.value === 'en-US' ? -92 : -150)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, false, true, 0, i18n.locale.value === 'en-US' ? -92 : -150, $t('TOTALREQ.STRESSCHECKRESULT'), 'STRESSCHECKRESULT', $t('TOOLTIP.' + getTooltipContent('ReportLaptoptoEmp')))"
                    :data-tooltipHeader = "$t('TOTALREQ.STRESSCHECKRESULT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportLaptoptoEmp'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <polygon transform="translate(0 -38)" points="718,722 726,722 726,729" class="background-green"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp')" width="34" height="30" x="700" y="684" 
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp') },
                    {'animate-report-laptop-to-emp': currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoEmp') },
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp') ? 'opacity: 0;' : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp') ? `animation-duration:${getActyStepDuration(stressChecksteps[1], 'AnimateLaptopgenerateReporttoEmp')}s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1],'AnimateLaptopgenerateReporttoEmp').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoEmp') ? `transition-duration:${getActyStepDuration(stressChecksteps[1], 'ReportLaptoptoEmp')}s; transition-delay: ${ getActyStepByStepNm(stressChecksteps[1],'ReportLaptoptoEmp').delay}s;` : '' ]
                  ]"
                >
                  <Person class="report" type="report2" size="smallWide2"
                    :growReport="currentStep >= getActyStepIndex(stressChecksteps[1], 'AnimateLaptopgenerateReporttoEmp')"
                    :duration="getActyStepDuration(stressChecksteps[1], 'AnimateLaptopgenerateReporttoEmp')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(288, 302)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('STRESSCHECKRESULT') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -40, i18n.locale.value === 'en-US' ? -92 : -150)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -40, i18n.locale.value === 'en-US' ? -92 : -150, $t('TOTALREQ.STRESSCHECKRESULT'), 'STRESSCHECKRESULT', $t('TOOLTIP.' + getTooltipContent('ReportLaptoptoEmp')))"
                    :data-tooltipHeader = "$t('TOTALREQ.STRESSCHECKRESULT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportLaptoptoEmp'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>

                <!-- Stress Check Result to Industrial Physician -->
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoIndusPhysician')" width="34" height="30" x="700" y="684" 
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoIndusPhysician') },
                    {'animate-report-laptop-to-physician': currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoIndusPhysician') },
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoIndusPhysician') ? 'opacity: 0;' : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateLaptopgenerateReporttoIndusPhysician') ? `animation-duration:${getActyStepDuration(stressChecksteps[1], 'AnimateLaptopgenerateReporttoIndusPhysician')}s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1],'AnimateLaptopgenerateReporttoIndusPhysician').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'ReportLaptoptoIndusPhysician') ? `animation-duration:${getActyStepDuration(stressChecksteps[1], 'ReportLaptoptoIndusPhysician')}s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1],'ReportLaptoptoIndusPhysician').delay}s;` : '' ]
                  ]"
                >
                  <Person class="report" type="report2" size="smallWide2"
                    :growReport="currentStep >= getActyStepIndex(stressChecksteps[1], 'AnimateLaptopgenerateReporttoEmp')"
                    :duration="getActyStepDuration(stressChecksteps[1], 'AnimateLaptopgenerateReporttoEmp')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1250, -52)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('STRESSCHECKRESULT') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -32, -24)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -32, -24, $t('TOTALREQ.STRESSCHECKRESULT'), 'STRESSCHECKRESULT', $t('TOOLTIP.' + getTooltipContent('ReportLaptoptoEmp')))"
                    :data-tooltipHeader = "$t('TOTALREQ.STRESSCHECKRESULT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportLaptoptoIndusPhysician'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>

                <!-- Employee Icon -->
                <foreignObject width="16" height="50" x="262" y="696">
                  <Person type="memberInactive" size="small1"/>
                </foreignObject>
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateEmpturnBlue')" width="16" height="50" x="262" y="696"
                  class="icon-fade-in"
                  :style="`animation-duration:${getActyStepDuration(stressChecksteps[1], 'AnimateEmpturnBlue')}s; animation-delay: ${ getActyStepByStepNm(stressChecksteps[1],'AnimateEmpturnBlue').delay}s;`"
                >
                  <Person type="memberActive" size="small1"/>
                </foreignObject>

                <!-- Stress Summary Report -->
                <rect width="54" height="50" x="338" y="376" fill="#C4BD97"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportIndusPhysiciantoTeam')"
                  width="54" height="50" x="1218" y="376" class="prev-report"
                >
                  <Person class="report" type="report3" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1256, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('STRESSSUMMARYREPORT') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.STRESSSUMMARYREPORT'), 'STRESSSUMMARYREPORT', $t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam')))"
                    :data-tooltipHeader = "$t('TOTALREQ.STRESSSUMMARYREPORT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportTeamtoLSO')"
                  width="54" height="50" x="338" y="376" class="prev-report"
                >
                  <Person class="report" type="report3" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(374, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('STRESSSUMMARYREPORT') }"
                   @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.STRESSSUMMARYREPORT'), 'STRESSSUMMARYREPORT', $t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam')))"
                    :data-tooltipHeader = "$t('TOTALREQ.STRESSSUMMARYREPORT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(stressChecksteps[1], 'AnimateIndusPhysiciangenerateReport')" width="54" height="50" x="1218" y="376" 
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(stressChecksteps[1], 'AnimateIndusPhysiciangenerateReport') },
                    {'animate-report-physician-to-team': currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportIndusPhysiciantoTeam') },
                    {'animate-team-to-lso': currentStep >= getActyStepIndex(stressChecksteps[1], 'ReportTeamtoLSO') }
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(stressChecksteps[1],'AnimateIndusPhysiciangenerateReport') ? 'opacity: 0;' : ''],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'AnimateIndusPhysiciangenerateReport') ? `animation-duration: ${ getActyStepDuration(stressChecksteps[1], 'AnimateIndusPhysiciangenerateReport') }s; animation-delay: ${getActyStepByStepNm(stressChecksteps[1],'AnimateIndusPhysiciangenerateReport').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'ReportIndusPhysiciantoTeam') ? `transition-duration: ${ getActyStepDuration(stressChecksteps[1], 'ReportIndusPhysiciantoTeam') }s; transition-delay: ${getActyStepByStepNm(stressChecksteps[1],'ReportIndusPhysiciantoTeam').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(stressChecksteps[1],'ReportTeamtoLSO') ? `animation-duration: ${ getActyStepDuration(stressChecksteps[1], 'ReportTeamtoLSO') }s; animation-delay: ${getActyStepByStepNm(stressChecksteps[1],'ReportTeamtoLSO').delay}s;` : '' ]
                  ]"
                >
                  <Person class="report" type="report3" size="medium3"
                    :growReport="currentStep >= getActyStepIndex(stressChecksteps[1], 'AnimateIndusPhysiciangenerateReport')"
                    :duration="getActyStepDuration(stressChecksteps[1], 'AnimateIndusPhysiciangenerateReport')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1188, -248)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('STRESSSUMMARYREPORT') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.STRESSSUMMARYREPORT'), 'STRESSSUMMARYREPORT', $t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam')))"
                    :data-tooltipHeader = "$t('TOTALREQ.STRESSSUMMARYREPORT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportIndusPhysiciantoTeam'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </template>   

              <!-- Monthly Workplace Inspection Icon -->
              <template v-if="selectedActvt === mnthlywrkplcinspctsteps[0] && actyDisplayCondition(setupsteps[0])">
                <!-- Industrial Physician icon -->
                <foreignObject v-if="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianfadein')" x="1236" y="326" class="icon-member"
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianfadein')},
                    {'animate-physician-to-facilities': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities')},
                    {'animate-physician-inspect-facilities': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysicianinspectFacilities')},
                    {'animate-physician-facilities-to-physician': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysicianFacilitiestoPhysician')}
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianfadein') ? 'opacity: 0;' : ''],
                    [ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianfadein') ? `animation-duration:${getActyStepDuration(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysicianfadein')}s; animation-delay: ${ getActyStepByStepNm(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianfadein').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'IndusPhysiciantoFacilities') ? `animation-duration:${getActyStepDuration(mnthlywrkplcinspctsteps[1], 'IndusPhysiciantoFacilities')}s; animation-delay: ${ getActyStepByStepNm(mnthlywrkplcinspctsteps[1],'IndusPhysiciantoFacilities').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianinspectFacilities') ? `animation-duration:${getActyStepDuration(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysicianinspectFacilities')}s; animation-delay: ${ getActyStepByStepNm(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianinspectFacilities').delayAccumulated}s;` : '' ],
                    [ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianFacilitiestoPhysician') ? `animation-duration:${getActyStepDuration(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysicianFacilitiestoPhysician')}s; animation-delay: ${ getActyStepByStepNm(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysicianFacilitiestoPhysician').delayAccumulated}s;` : '' ]
                  ]"
                >
                  <Person type="physician" size="small1"/>
                </foreignObject>
                <!-- Report Icon -->
                <rect width="54" height="50" x="338" y="376" fill="#C4BD97"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam')"
                  width="54" height="50" x="1218" y="376" class="prev-report"
                >
                  <Person class="report" type="report3" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1256, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                  :class="{ 'tooltip-active': keepTooltipsIds.includes('MTHLYINSPECTIONCHECKLIST') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.INSPECTIONCHECKLIST'), 'MTHLYINSPECTIONCHECKLIST', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                    :data-tooltipHeader = "$t('TOTALREQ.INSPECTIONCHECKLIST')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords')"
                  width="54" height="50" x="338" y="376" class="prev-report"
                >
                  <Person class="report" type="report3" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(374, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                  :class="{ 'tooltip-active': keepTooltipsIds.includes('MTHLYINSPECTIONCHECKLIST') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.INSPECTIONCHECKLIST'), 'MTHLYINSPECTIONCHECKLIST', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                    :data-tooltipHeader = "$t('TOTALREQ.INSPECTIONCHECKLIST')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysiciangenerateReport')" width="54" height="50" x="1218" y="376" 
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysiciangenerateReport') },
                    {'animate-report-physician-to-team': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam') },
                    {'animate-team-to-records': currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords') }
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysiciangenerateReport') ? 'opacity: 0;' : ''],
                    [ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysiciangenerateReport') ? `animation-duration: ${ getActyStepDuration(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysiciangenerateReport') }s; animation-delay: ${getActyStepByStepNm(mnthlywrkplcinspctsteps[1],'AnimateIndusPhysiciangenerateReport').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'ReportIndusPhysiciantoTeam') ? `transition-duration: ${ getActyStepDuration(mnthlywrkplcinspctsteps[1], 'ReportIndusPhysiciantoTeam') }s; transition-delay: ${getActyStepByStepNm(mnthlywrkplcinspctsteps[1],'ReportIndusPhysiciantoTeam').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1],'ReportTeamtoRecords') ? `animation-duration: ${ getActyStepDuration(mnthlywrkplcinspctsteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${getActyStepByStepNm(mnthlywrkplcinspctsteps[1],'ReportTeamtoRecords').delay}s;` : '' ]
                  ]"
                >
                  <Person class="report" type="report3" size="medium3"
                    :growReport="currentStep >= getActyStepIndex(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysiciangenerateReport')"
                    :duration="getActyStepDuration(mnthlywrkplcinspctsteps[1], 'AnimateIndusPhysiciangenerateReport')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(618, 169)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('MTHLYINSPECTIONCHECKLIST') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.INSPECTIONCHECKLIST'), 'MTHLYINSPECTIONCHECKLIST', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                    :data-tooltipHeader = "$t('TOTALREQ.INSPECTIONCHECKLIST')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </template>

              <!--Health Committee Meeting Icon-->
              <template v-if="selectedActvt === commttMtgsteps[0] && actyDisplayCondition(commttMtgsteps[0])">
                <!--Industrial Physician icon-->
                <foreignObject v-if="currentStep >= getActyStepIndex(commttMtgsteps[1],'AnimateIndusPhysicianfadein')" x="1236" y="326" class="icon-member"
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(commttMtgsteps[1],'AnimateIndusPhysicianfadein')},
                    {'animate-physician-to-team': currentStep >= getActyStepIndex(commttMtgsteps[1], 'IndusPhysiciantoComp')},
                    {'animate-physician-comp-to-physician': currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimateIndusPhysicianComptoPhysician')}
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(commttMtgsteps[1],'AnimateIndusPhysicianfadein') ? 'opacity: 0;' : ''],
                    [ currentStep >= getActyStepIndex(commttMtgsteps[1],'AnimateIndusPhysicianfadein') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimateIndusPhysicianfadein')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimateIndusPhysicianfadein').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(commttMtgsteps[1], 'IndusPhysiciantoComp') ? `transition-duration:${getActyStepDuration(commttMtgsteps[1], 'IndusPhysiciantoComp')}s; transition-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'IndusPhysiciantoComp').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimateIndusPhysicianComptoPhysician') ? `transition-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimateIndusPhysicianComptoPhysician')}s; transition-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimateIndusPhysicianComptoPhysician').delay}s;` : '' ]
                  ]"
                >
                  <Person type="physician" size="small1" :class="{ inactivemember : !needsIndusPhysician }"/>
                </foreignObject>
                
                <!-- Report Icon -->
                <rect width="54" height="50" x="338" y="376" fill="#C4BD97"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(commttMtgsteps[1],'ReportTeamtoRecords')" x="338" y="376" width="54" height="50" class="prev-report">
                  <Person class="report" type="report3" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(374, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('MEETINGSUMMARY') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.MEETINGSUMMARY'), 'MEETINGSUMMARY', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                    :data-tooltipHeader = "$t('TOTALREQ.MEETINGSUMMARY')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(commttMtgsteps[1],'AnimateTeamgenerateReporttoRecords')" width="54" height="50" x="338" y="376"
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(commttMtgsteps[1],'AnimateTeamgenerateReporttoRecords')},
                    {'animate-team-to-records': currentStep >= getActyStepIndex(commttMtgsteps[1],'ReportTeamtoRecords')}
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(commttMtgsteps[1],'AnimateTeamgenerateReporttoRecords') ? 'opacity: 0;' : ''],
                    [ currentStep >= getActyStepIndex(commttMtgsteps[1],'AnimateTeamgenerateReporttoRecords') ? `animation-duration: ${ getActyStepDuration(commttMtgsteps[1], 'AnimateTeamgenerateReporttoRecords') }s; animation-delay: ${getActyStepByStepNm(commttMtgsteps[1],'AnimateTeamgenerateReporttoRecords').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(commttMtgsteps[1],'ReportTeamtoRecords') ? `animation-duration: ${ getActyStepDuration(commttMtgsteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${getActyStepByStepNm(commttMtgsteps[1],'ReportTeamtoRecords').delay}s;` : '' ]
                  ]"
                >
                  <Person class="report" type="report3" size="medium3"
                    :growReport="currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimateTeamgenerateReporttoRecords')"
                    :duration="getActyStepDuration(commttMtgsteps[1], 'AnimateTeamgenerateReporttoRecords')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(618, 169)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('MEETINGSUMMARY') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.MEETINGSUMMARY'), 'MEETINGSUMMARY', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                    :data-tooltipHeader = "$t('TOTALREQ.MEETINGSUMMARY')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                
                <!-- Personnel -->
                <g v-if="currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') && currentStep < commttMtgsteps[1].length - 1" class="personnel-row">
                  <foreignObject v-for="i in neededNoOfPersonnel" :key="i" 
                    :x="318 + ((i - 1) % 6)*16"
                    :y="(i - 1) < 6 ? 260 : 200"
                    class="icon-member"
                  >
                    <Person type="memberActive" size="small1"
                      :class="[
                        { 'icon-fade-in': currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') },
                        { 'icon-fade-out': currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') }
                      ]"
                      :style="[
                        [ currentStep <= getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') ? 'opacity: 0;' : ''],
                        [ currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimateMtg') ? `animation-duration: 0.5s; animation-delay: ${(i-1)*0.11}s;` : '' ],
                        [ currentStep >= getActyStepIndex(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam') ? `animation-duration:${getActyStepDuration(commttMtgsteps[1], 'AnimatePersonnelfadeinInTeam')}s; animation-delay: ${ getActyStepByStepNm(commttMtgsteps[1],'AnimatePersonnelfadeinInTeam').delay}s;` : '' ],
                      ]"
                    />
                  </foreignObject>
                </g>
              </template>

              <!--Weekly Workplace Inspection Icon-->
              <template v-if="selectedActvt === weeklywrkplcinspctsteps[0] &&actyDisplayCondition(weeklywrkplcinspctsteps[0])">
                <!-- Health Officer icon -->
                <foreignObject v-if="currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'OfficertoFacilities')" x="182" y="388" class="icon-member"
                  :class="[
                    { 'animate-hlthofficer-to-facilities': currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'OfficertoFacilities')},
                    { 'animate-hlthofficer-inspect-facilities': currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateOfficerinspectFacilities')},
                    { 'animate-hlthofficer-facilities-to-team': currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateOfficerFacilitiestoTeam')},
                  ]"
                  :style="[
                    [ currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'OfficertoFacilities') ? `animation-duration:${getActyStepDuration(weeklywrkplcinspctsteps[1], 'OfficertoFacilities')}s; animation-delay: ${ getActyStepByStepNm(weeklywrkplcinspctsteps[1],'OfficertoFacilities').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateOfficerinspectFacilities') ? `animation-duration:${getActyStepDuration(weeklywrkplcinspctsteps[1], 'AnimateOfficerinspectFacilities')}s; animation-delay: ${ getActyStepByStepNm(weeklywrkplcinspctsteps[1],'AnimateOfficerinspectFacilities').delayAccumulated}s;` : '' ],
                    [ currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateOfficerFacilitiestoTeam') ? `animation-duration:${getActyStepDuration(weeklywrkplcinspctsteps[1], 'AnimateOfficerFacilitiestoTeam')}s; animation-delay: ${ getActyStepByStepNm(weeklywrkplcinspctsteps[1],'AnimateOfficerFacilitiestoTeam').delayAccumulated}s;` : '' ],
                  ]"
                >
                  <Person type="memberActive" size="small1"/>
                </foreignObject>
                <!-- Report Icon -->
                <rect width="54" height="50" x="338" y="376" fill="#C4BD97"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'ReportTeamtoRecords')" x="338" y="376" width="54" height="50" class="prev-report">
                  <Person class="report" type="report3" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(374, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('WKLYINSPECTIONCHECKLIST') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.INSPECTIONCHECKLIST'), 'WKLYINSPECTIONCHECKLIST', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                    :data-tooltipHeader = "$t('TOTALREQ.INSPECTIONCHECKLIST')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateTeamgenerateReporttoRecords')" width="54" height="50" x="338" y="376" 
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateTeamgenerateReporttoRecords')},
                    {'animate-team-to-records': currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'ReportTeamtoRecords')}
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateTeamgenerateReporttoRecords') ? 'opacity: 0;' : ''],
                    [ currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'AnimateTeamgenerateReporttoRecords') ? `animation-duration: ${ getActyStepDuration(weeklywrkplcinspctsteps[1], 'AnimateTeamgenerateReporttoRecords') }s; animation-delay: ${getActyStepByStepNm(weeklywrkplcinspctsteps[1],'AnimateTeamgenerateReporttoRecords').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1],'ReportTeamtoRecords') ? `animation-duration: ${ getActyStepDuration(weeklywrkplcinspctsteps[1], 'ReportTeamtoRecords') }s; animation-delay: ${getActyStepByStepNm(weeklywrkplcinspctsteps[1],'ReportTeamtoRecords').delay}s;` : '' ]
                  ]"
                >
                  <Person class="report" type="report3" size="medium3"
                    :growReport="currentStep >= getActyStepIndex(weeklywrkplcinspctsteps[1], 'AnimateTeamgenerateReporttoRecords')"
                    :duration="getActyStepDuration(weeklywrkplcinspctsteps[1], 'AnimateTeamgenerateReporttoRecords')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(618, 169)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('WKLYINSPECTIONCHECKLIST') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.INSPECTIONCHECKLIST'), 'WKLYINSPECTIONCHECKLIST', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords')))"
                    :data-tooltipHeader = "$t('TOTALREQ.INSPECTIONCHECKLIST')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoRecords'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </template>

              <!--Personnel Appointment Icon-->
              <template v-if="selectedActvt == prsnlAppntmntsteps[0] && actyDisplayCondition(prsnlAppntmntsteps[0])">
                <!-- Former personnel returns to regular employee -->
                <foreignObject :x="nbHlthOfficer ? 182 : (nbHlthPromoter > 0 ? 192 : 48)" :y="nbHlthOfficer > 0 ? 388 : 264" class="icon-member"
                  :class="[
                    { 'animate-team-to-emp-hlthpromoter': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateTeamtoEmp') && nbHlthPromoter > 0},
                    { 'animate-team-to-emp-hlthSftypromoter': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateTeamtoEmp') && nbHlthSftyPromoter > 0},
                    { 'animate-team-to-emp-officer': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateTeamtoEmp') && nbHlthOfficer > 0},
                    { 'icon-fade-out': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnTan') && nbHlthOfficer > 0},
                  ]"
                  :style="[
                    [currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateTeamtoEmp') ? `transition-duration:${getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateTeamtoEmp')}s; transition-delay: ${ getActyStepByStepNm(prsnlAppntmntsteps[1],'AnimateTeamtoEmp').delay}s;` : ''], 
                    [currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnTan') ? 
                      `animation-duration:${getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateEmpturnTan')}s; animation-delay: ${ getActyStepByStepNm(prsnlAppntmntsteps[1],'AnimateEmpturnTan').delay}s;` : ''
                    ]
                  ]"
                >
                  <Person type="memberActive" size="small1"/>
                </foreignObject>
                <foreignObject v-if="currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'AnimateEmpturnTan')" x="262" y="696" class="icon-member"
                  :class="{ 'icon-fade-in': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnTan')}"
                  :style="currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnTan') ? `animation-duration:${getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateEmpturnTan')}s; animation-delay: ${ getActyStepByStepNm(prsnlAppntmntsteps[1],'AnimateEmpturnTan').delay}s; opacity: 0;` : '' "
                >
                  <Person type="memberInactive" size="small1"/>
                </foreignObject>

                <!-- New personnel enters team-->
                <foreignObject x="182" y="696" class="icon-member" 
                  :class="{ 'icon-fade-out': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'AnimateEmpturnBlue') }"
                  :style="[currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnBlue') ? `animation-duration: ${getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateEmpturnBlue')}s; animation-delay: ${ getActyStepByStepNm(prsnlAppntmntsteps[1],'AnimateEmpturnBlue').delay}s;` : '']"
                >
                  <Person type="memberInactive" size="small1"/>
                </foreignObject>
                <foreignObject v-if="currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnBlue')" x="182" y="696" class="icon-member"
                  :class="[
                    { 'icon-fade-in': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnBlue')},
                    { 'animate-emp-to-team-hlthpromoter': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmptoTeam') && nbHlthPromoter > 0},
                    { 'animate-emp-to-team-hlthSftypromoter': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmptoTeam') && nbHlthSftyPromoter > 0},
                    { 'animate-emp-to-team-officer': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmptoTeam') && nbHlthOfficer > 0}
                  ]"
                  :style="[
                    [ currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmpturnBlue') ? `animation-duration: ${getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateEmpturnBlue')}s; animation-delay: ${ getActyStepByStepNm(prsnlAppntmntsteps[1],'AnimateEmpturnBlue').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'AnimateEmptoTeam') ? `transition-duration:${getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateEmptoTeam')}s; transition-delay: ${ getActyStepByStepNm(prsnlAppntmntsteps[1],'AnimateEmptoTeam').delay}s;` : '' ],
                  ]"
                >
                  <Person type="memberActive" size="small1"/>
                </foreignObject>

                <!-- Report -->
                <rect width="54" height="50" x="338" y="376" fill="#C4BD97"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'ReportTeamtoLSO')" x="338" y="376" width="54" height="50" class="prev-report">
                  <Person class="report" type="report2" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(374, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('POSITIONAPPOINTMENTREPORTS') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.POSITIONAPPOINTMENTREPORTS'), 'POSITIONAPPOINTMENTREPORTS', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO')))"
                    :data-tooltipHeader = "$t('TOTALREQ.POSITIONAPPOINTMENTREPORTS')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO')" width="54" height="50" x="338" y="376" 
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO') },
                    {'animate-team-to-lso': currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'ReportTeamtoLSO') },
                  ]"
                  :style="[
                    [ currentStep === getActyStepIndex(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO') ? 'opacity: 0;' : '' ],
                    [ currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO') ? `animation-duration:${getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO')}s; animation-delay: ${getActyStepByStepNm(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO').delay}s;` : '' ],
                    [ currentStep >= getActyStepIndex(prsnlAppntmntsteps[1],'ReportTeamtoLSO') ? `animation-duration:${getActyStepDuration(prsnlAppntmntsteps[1], 'ReportTeamtoLSO')}s; animation-delay: ${getActyStepByStepNm(prsnlAppntmntsteps[1], 'ReportTeamtoLSO').delay}s;` : '' ],
                  ]"
                >
                  <Person class="report" type="report2" size="medium3"
                    :growReport="currentStep >= getActyStepIndex(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO')"
                    :duration="getActyStepDuration(prsnlAppntmntsteps[1], 'AnimateTeamgenerateReporttoLSO')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1188, -248)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('POSITIONAPPOINTMENTREPORTS') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.POSITIONAPPOINTMENTREPORTS'), 'POSITIONAPPOINTMENTREPORTS', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO')))"
                    :data-tooltipHeader = "$t('TOTALREQ.POSITIONAPPOINTMENTREPORTS')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </template>
              
              <!--Incident Reporting Icon-->
              <template v-if="selectedActvt == incdntRprtngsteps[0]">
                <!--Employee icon--> 
                <foreignObject v-if="currentStep <= getActyStepIndex(incdntRprtngsteps[1], 'AnimateEmpturnBlue')" x="262" y="696" class="icon-member"
                  :class="{'icon-fade-out': currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateEmpturnBlue') }"
                  :style="`animation-duration:${getActyStepDuration(incdntRprtngsteps[1], 'AnimateEmpturnBlue')}s; animation-delay: ${getActyStepByStepNm(incdntRprtngsteps[1], 'AnimateEmpturnBlue').delay}s;`"
                >
                  <Person type="memberInactive" size="small1"/>
                </foreignObject>
                <foreignObject v-if="currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateEmpturnBlue')" width="24" height="75" x="262" y="696"
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateEmpturnBlue') },
                    {'animate-emp-fall': currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateEmpFall') },
                    {'animate-emp-stand': currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateEmpStand') }
                  ]"
                  :style="[
                    'overflow: visible',
                    [
                      currentStep >= getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpturnBlue') ?`animation-duration:${getActyStepDuration(incdntRprtngsteps[1], 'AnimateEmpturnBlue')}s; animation-delay: ${getActyStepByStepNm(incdntRprtngsteps[1], 'AnimateEmpturnBlue').delay}s; opacity: 0;` : ''
                    ],
                    [
                      currentStep >= getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpFall') ?`animation-duration:${getActyStepDuration(incdntRprtngsteps[1], 'AnimateEmpFall')}s; animation-delay: ${getActyStepByStepNm(incdntRprtngsteps[1], 'AnimateEmpFall').delay}s; opacity: 1;` : ''
                    ],
                  ]"
                >
                  <Person type="memberActive" size="small1" class="emp-position"
                    :class="{'rotate-stand': getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpStandup')  }"
                    :style="[
                      [currentStep == getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpFall') ?`transition-duration: 0.3s; transition-delay: 0.2s;` : ''],
                      [currentStep >= getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpStand') ?`transition-duration: ${getActyStepDuration(incdntRprtngsteps[1], 'AnimateEmpStand')}s; transition-delay: ${getActyStepDuration(incdntRprtngsteps[1], 'AnimateEmpStand').delay}s;` : ''],
                    ]"
                  />
                </foreignObject>
                <template v-if="currentStep == getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpCry')">
                  <!--Employee face-->
                  <line class="emp-emotion" x1="343" y1="726" x2="343" y2="729"></line>
                  <line class="emp-emotion" x1="343" y1="732" x2="343" y2="735"></line>
                  <path class="emp-emotion" d="M335,730 h4 v4" fill="none"></path>
                  
                  <!--Emotion strikes-->
                  <line class="emp-emotion" x1="330" y1="712" x2="334" y2="720"></line>
                  <line class="emp-emotion" x1="344" y1="708" x2="342" y2="720"></line>
                  <line class="emp-emotion" x1="356" y1="710" x2="350" y2="721"></line>
                </template>
                <template v-if="currentStep == getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpFall')">
                  <line class="emp-emotion strike-fall" x1="300" y1="728" x2="304" y2="725"></line>
                  <line class="emp-emotion strike-fall" x1="300" y1="732" x2="305" y2="732"></line>
                  <line class="emp-emotion strike-fall" x1="300" y1="736" x2="304" y2="739"></line>
                </template>
                <template v-if="currentStep == getActyStepIndex(incdntRprtngsteps[1],'AnimateEmpSmile')">
                  <!--Employee face-->
                  <line class="emp-emotion" x1="309" y1="701" x2="312" y2="701"></line>
                  <line class="emp-emotion" x1="315" y1="701" x2="318" y2="701"></line>
                  <path class="emp-emotion" d="M311,705 l3,3 l3,-3" fill="none"></path>
                </template>
                  
                <!--Report Team to LSO-->
                <rect width="54" height="50" x="338" y="376" fill="#C4BD97"/>
                <foreignObject v-if="currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'ReportTeamtoLSO')" x="338" y="376" width="54" height="50" class="prev-report">
                  <Person class="report" type="report2" size="medium3"/>
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(374, 10)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('INCIDENTREPORT') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.INCIDENTREPORT'), 'INCIDENTREPORT', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO')))"
                    :data-tooltipHeader = "$t('TOTALREQ.INCIDENTREPORT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
                <foreignObject v-if="currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateTeamgenerateReporttoLSO')" width="54" height="50" x="338" y="376" 
                  :class="[
                    {'icon-fade-in': currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateTeamgenerateReporttoLSO') },
                    {'animate-team-to-lso': currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'ReportTeamtoLSO') },
                  ]"
                  :style="[
                    [ currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateTeamgenerateReporttoLSO') ? `animation-duration:${getActyStepDuration(incdntRprtngsteps[1], 'AnimateTeamgenerateReporttoLSO')}s; animation-delay: ${getActyStepByStepNm(incdntRprtngsteps[1], 'AnimateTeamgenerateReporttoLSO').delay}s; opacity: 0;` : '' ],
                    [ currentStep >= getActyStepIndex(incdntRprtngsteps[1],'ReportTeamtoLSO') ? `animation-duration:${getActyStepDuration(incdntRprtngsteps[1], 'ReportTeamtoLSO')}s; animation-delay: ${getActyStepByStepNm(incdntRprtngsteps[1], 'ReportTeamtoLSO').delay}s; opacity: 1;` : '' ],
                  ]"
                >
                  <Person class="report" type="report2" size="medium3"
                    :growReport="currentStep >= getActyStepIndex(incdntRprtngsteps[1], 'AnimateTeamgenerateReporttoLSO')"
                    :duration="getActyStepDuration(incdntRprtngsteps[1], 'AnimateTeamgenerateReporttoLSO')"
                  />
                </foreignObject>
                <g v-if="currentStep === selectedActySteps[1].length - 1" transform="translate(1188, -248)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512" class="tooltip-question-mark-svg"
                    :class="{ 'tooltip-active': keepTooltipsIds.includes('INCIDENTREPORT') }"
                    @mouseenter="showTooltipByOpt($event, true, true, -44, -40)"
                    @mouseleave="closeTooltip()"
                    @click.left.stop.prevent="keepTooltipOpen($event, true, true, -44, -40, $t('TOTALREQ.INCIDENTREPORT'), 'INCIDENTREPORT', $t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO')))"
                    :data-tooltipHeader = "$t('TOTALREQ.INCIDENTREPORT')" 
                    :data-tooltipContent = "$t('TOOLTIP.' + getTooltipContent('ReportTeamtoLSO'))"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z m169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2z M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                  </svg>
                </g>
              </template>
            </g>
          </svg>
        </div> 
      </div>
      <div class="bottom-container">
        <div style="display: flex; align-items: end;">
          <button class="locale" @click="switchLocale()">
            <div><span :class="{ 'text-locale-jp': i18n.locale.value === 'en-US' }">{{ localeToChange }}</span></div>
          </button>
          <button id="fullscreen" @click="openFullscreen()">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
                <template v-if="isFullScreen">
                  <path d="M8.41425 7.00003L8.41425 4.41425L10.4142 4.41425L10.4142 9.41425C10.4142 9.67946 10.3089 9.93382 10.1214 10.1214C9.93382 10.3089 9.67946 10.4142 9.41425 10.4142L4.41425 10.4142L4.41425 8.41425L7.00003 8.41425L3 4.41422L4.41422 3L8.41425 7.00003Z"></path>
                  <path d="M17.0097 8.41425L21 4.42398L19.5858 3.00977L15.5858 7.0098L15.5858 4.42401L13.5858 4.42401L13.5858 9.41424C13.5858 9.67946 13.6911 9.93382 13.8787 10.1214C14.0662 10.3089 14.3205 10.4142 14.5858 10.4142L19.5858 10.4142L19.5858 8.41425L17.0097 8.41425Z"></path>
                  <path d="M8.41419 17L4.41421 21L3 19.5858L6.99997 15.5858L4.41419 15.5858L4.41419 13.5858L9.41419 13.5858C9.96647 13.5858 10.4142 14.0335 10.4142 14.5858L10.4142 19.5858L8.41419 19.5858L8.41419 17Z"></path>
                  <path d="M15.5858 16.9986L19.5855 21L21 19.5861L17.0015 15.5858L19.5813 15.5858L19.5813 13.5858L14.5858 13.5858C14.3206 13.5858 14.0662 13.6912 13.8787 13.8787C13.6912 14.0662 13.5858 14.3206 13.5858 14.5858L13.5858 19.5858L15.5858 19.5858L15.5858 16.9986Z"></path>
                </template>
                <path v-else d="M16 5L17.5858 5L14.2929 8.29292C13.9024 8.68345 13.9024 9.31661 14.2929 9.70714C14.6834 10.0977 15.3166 10.0977 15.7071 9.70714L19 6.41426V8C19 8.55228 19.4477 9 20 9C20.5523 9 21 8.55228 21 8V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3H16C15.4477 3 15 3.44772 15 4C15 4.55228 15.4477 5 16 5ZM5 8.00002V6.4142L8.29292 9.70712C8.68345 10.0976 9.31661 10.0976 9.70714 9.70712C10.0977 9.3166 10.0977 8.68343 9.70714 8.29291L6.41424 5.00001L8 5.00002C8.55228 5.00002 9 4.5523 9 4.00002C9 3.44773 8.55228 3.00002 8 3.00002H4C3.73478 3.00002 3.48043 3.10537 3.29289 3.29291C3.10536 3.48044 3 3.7348 3 4.00002V8.00002C3 8.5523 3.44772 9.00001 4 9.00001C4.55228 9.00001 5 8.5523 5 8.00002ZM8.00002 19H6.4142L9.70712 15.7071C10.0976 15.3166 10.0976 14.6834 9.70712 14.2929C9.3166 13.9024 8.68343 13.9024 8.29291 14.2929L5.00001 17.5858V16C5.00001 15.4477 4.5523 15 4.00001 15C3.44773 15 3.00002 15.4477 3.00002 16L3.00002 20C3.00002 20.2652 3.10537 20.5196 3.29291 20.7071C3.48044 20.8947 3.7348 21 4.00002 21H8.00002C8.5523 21 9.00001 20.5523 9.00001 20C9.00001 19.4477 8.5523 19 8.00002 19ZM19 17.5858V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8947 20.2652 21 20 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H17.5858L14.2929 15.7071C13.9023 15.3166 13.9023 14.6834 14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19 17.5858Z"></path>
              </svg>
            </div>
          </button>
          <!-- Reset button -->
          <button class="reset" :class="{ 'text-locale-jp': i18n.locale.value === 'ja-JP' }" @click="reset">
            <div><span>{{$t("BUTTON.RESET")}}</span></div>
          </button>
        </div>
      </div>
    </div>
    <Tooltip
      v-if="tooltipIsOn && keepTooltips.length === 0"
      :tooltipPosition="tooltip.position"
      :header="tooltip.header"
      :content="tooltip.content"
    >
    </Tooltip>
    <template v-if="true">
      <Tooltip v-for="(p, i) in keepTooltips" :id="`tooltip-${p.id}`" :key="p.id"
        :tooltipPosition="{ 
          left: p.left,
          top: p.top,
          width: p.width,
          zIndex: forewardmostTooltip === p.id ? 99 : 1,
        }"
        :header="p.header"
        :content="p.content"
        @click.stop="forewardmostTooltip = p.id"
        @mousedown.stop="startMoveTooltip($event, p.id, i)"
      >
        <template #tooltip-header-control>
          <button class="button-normal" @click.prevent.stop="closeKeptTooltip(i)">
            <svg xmlns="http://www.w3.org/2000/svg" width="12"  viewBox="0 0 512 512" fill="black">
              <path d="M 464 32 H 48 C 21.5 32 0 53.5 0 80 v 352 c 0 26.5 21.5 48 48 48 h 416 c 26.5 0 48 -21.5 48 -48 V 80 c 0 -26.5 -21.5 -48 -48 -48 Z m -83.6 290.5 c 4.8 4.8 4.8 12.6 0 17.4 l -40.5 40.5 c -4.8 4.8 -12.6 4.8 -17.4 0 L 256 313.3 l -66.5 67.1 c -4.8 4.8 -12.6 4.8 -17.4 0 l -40.5 -40.5 c -4.8 -4.8 -4.8 -12.6 0 -17.4 l 67.1 -66.5 l -67.1 -66.5 c -4.8 -4.8 -4.8 -12.6 0 -17.4 l 40.5 -40.5 c 4.8 -4.8 12.6 -4.8 17.4 0 l 66.5 67.1 l 66.5 -67.1 c 4.8 -4.8 12.6 -4.8 17.4 0 l 40.5 40.5 c 4.8 4.8 4.8 12.6 0 17.4 L 313.3 256 l 67.1 66.5 Z"/>
            </svg>  
          </button>
        </template>
      </Tooltip>
    </template>
  </div>
</template>
<script setup>
import { ref, computed, watch } from "vue";
import { useRequirements } from "@/composable/Requirements.js";
import { useTooltip } from '@/composable/Tooltip.js';
import 'vue-slider-component/theme/default.css';
import { useI18n } from "vue-i18n/index";
import VueSlider from 'vue-slider-component';
import Tooltip from '@/components/Tooltip.vue';
import Person from "@/components/IconPerson.vue";

let size = ref(50);
let coType = ref('office');

var {
  nbCmpnyMgmt,
  nbHlthSftyManager,
  nbHlthPromoter,
  nbHlthSftyPromoter,
  nbSftyOfficer,
  nbHlthOfficer,
  nbEmplyRepresentative,
  needsAnnlHlthChck,
  needsAnnlStrssCheck,
  needsMnthlyWrkPlcInspect,
  needsMnthlyHlthCmmttMeeting,
  needsWklyWrkPlcInspect,
  needsAdhocPrsnlReporting,
  needsAdhocIncdntReporting,
  needsSetup,
  needsIndusPhysician,
} = useRequirements(size, coType)

const neededNoOfPersonnel = computed(() => {
  return nbCmpnyMgmt.value + nbHlthSftyManager.value + nbHlthPromoter.value + nbHlthSftyPromoter.value + nbSftyOfficer.value + nbHlthOfficer.value + nbEmplyRepresentative.value
})

// Language change
const i18n = useI18n()
const localeToChange = computed(() => {
    if (i18n.locale.value === 'en-US'){
      return '日本語'
    } else return 'English'
  })

function switchLocale() {
  i18n.locale.value === 'en-US'?
  i18n.locale.value = 'ja-JP' :
  i18n.locale.value = 'en-US'
}

const points = [
  {
    value: 1,
    step: 1,
  },
  {
    value: 10,
    step: 5,
  },
  {
    value: 50,
    step: 5,
  },
  {
    value: 100,
    step: 50,
  },
  {
    value: 500,
    step: 50,
  },
  {
    value: 1000,
    step: 200,
  },
  {
    value: 3000,
    step: 100,
  },
];

let sizes = computed(() => {
  let result = [];
    points.forEach((point, idx) => {
      const lastPointValue = points[points.length - 1].value;

      if (point.value === lastPointValue) {
        return;
      }
      else {
        const nextPoint = points[idx + 1];

        for (let i = point.value; i <= nextPoint.value; i += point.step) {
          result.push(i);
        }
      }
    });

    const uniqueValues = new Set(result);
    return [...uniqueValues];
})

let marks = computed(() => {
   return points.map(point => point.value);
})

const {
  tooltipIsOn,
  tooltip,
  keepTooltips,
  forewardmostTooltip,
  showTooltip,
  keepTooltipOpen,
  closeTooltip,
  closeKeptTooltip,
  startMoveTooltip,
  moveTooltip,
  dropTooltip,
} = useTooltip(380)

function removeFocus(e) {
  e.target.blur()
}

const filterCompanyTypes = [
  { label: 'office', content: 'OFFICE'},
  { label: 'retail', content: 'RETAIL'},
  { label: 'construction', content: 'CONSTRUCTION'}
]

const defaultsteps = ['default', [ {name: "Default", duration: 0, delay: 0}]]
const setupsteps = ['setup', [
  {name: "Default", duration: 0, delay: 0},
  {name: "AnimatePersonnelfadeinOutTeam", duration: 1, delay: 0.5},
  {name: "AnimateTeamgenerateReporttoRecords", duration: 0.5, delay: 0}, 
  {name: "ReportTeamtoRecords", duration: 1, delay: 0.25},
  {name: "AnimatePersonnelfadeinInTeam", duration: 0.75, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0},
]]
const healthChecksteps = ['healthCheck', [
  {name: "Default", duration: 0, delay: 0},
  {name: "AnimateEmpturnBlue", duration: 0.75, delay: 0.5}, 
  {name: "AnimateEmptoCompEdge", duration: 0.5, delay: 0}, 
  {name: "EmptoClinic", duration: 1.5, delay: 0}, 
  {name: "AnimateEmptakeHealthCheckBlink", duration: 0.3, delay: 0}, 
  {name: "AnimateEmptakeHealthCheckMove", duration: 1.25, delay: 0}, 
  {name: "EmpClinictoComp", duration: 1.5, delay: 0}, 
  {name: "AnimateEmptoCompCenter", duration: 0.5, delay: 0}, 
  {name: "AnimateClinicgenerateReporttoEmp", duration: 1.5, delay: 0}, 
  {name: "AnimateReportClinictoEmp", duration: 1.5, delay: 0},
  // For 50 or more employees, these below steps are needed: //
  {name: "AnimateClinicgenerateReporttoIndusPhysician", duration: 1.5, delay: 0}, 
  {name: "ReportClinictoIndusPhysician", duration: 0.75, delay: 0}, 
  {name: "AnimateIndusPhysiciangenerateReporttoTeam", duration: 2, delay: 0.35}, 
  {name: "ReportIndusPhysiciantoRecords", duration: 1, delay: 0}, 
  {name: "ReportIndusPhysiciantoTeam", duration: 1.5, delay: 0.25}, 
  {name: "ReportTeamtoLSO", duration: 1.75, delay: 0.25}, 
  {name: "ReportTeamtoRecords", duration: 1, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const healthCheckstepsNoPhysician = ['healthCheck', [
{name: "Default", duration: 0, delay: 0},
  {name: "AnimateEmpturnBlue", duration: 0.75, delay: 0.5}, 
  {name: "AnimateEmptoCompEdge", duration: 0.5, delay: 0}, 
  {name: "EmptoClinic", duration: 1.5, delay: 0}, 
  {name: "AnimateEmptakeHealthCheckBlink", duration: 0.3, delay: 0}, 
  {name: "AnimateEmptakeHealthCheckMove", duration: 1.25, delay: 0}, 
  {name: "EmpClinictoComp", duration: 1.5, delay: 0}, 
  {name: "AnimateEmptoCompCenter", duration: 0.5, delay: 0}, 
  {name: "AnimateClinicgenerateReporttoEmp", duration: 1.5, delay: 0}, 
  {name: "AnimateReportClinictoEmp", duration: 1.5, delay: 0},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const stressChecksteps = ['stressCheck', [
  {name: "Default", duration: 0, delay: 0},
  {name: "AnimateEmpturnBlue", duration: 0.75, delay: 0},    
  {name: "AnimateEmpgenerateReport", duration: 0.75, delay: 0}, 
  {name: "ReportEmptoLaptop", duration: 1.25, delay: 0},  
  {name: "AnimateLaptopgenerateReporttoEmp", duration: 1, delay: 0.5},  
  {name: "ReportLaptoptoEmp", duration: 1.25, delay: 0.25},  
  {name: "AnimateLaptopgenerateReporttoIndusPhysician", duration: 1, delay: 0},  
  {name: "ReportLaptoptoIndusPhysician", duration: 1.25, delay: 0},  
  {name: "AnimateIndusPhysiciangenerateReport", duration: 1, delay: 0.5},  
  {name: "ReportIndusPhysiciantoTeam", duration: 1.75, delay: 0.25},  
  {name: "ReportTeamtoLSO", duration: 1.75, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const mnthlywrkplcinspctsteps = ['mnthlywrkplcinspct', [
  {name: "Default", duration: 0, delay: 0},
  {name: "AnimateIndusPhysicianfadein", duration: 0.75, delay: 0},
  {name: "IndusPhysiciantoFacilities", duration: 1, delay: 0},
  {name: "AnimateIndusPhysicianinspectFacilities", duration: 1.5, delay: 0, delayAccumulated: 1},
  {name: "AnimateIndusPhysicianFacilitiestoPhysician", duration: 1, delay: 0, delayAccumulated: 2.5},
  {name: "AnimateIndusPhysiciangenerateReport", duration: 1, delay: 0.4}, 
  {name: "ReportIndusPhysiciantoTeam", duration: 1.5, delay: 0.25}, 
  {name: "ReportTeamtoRecords", duration: 1, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const commttMtgsteps = ['commttMtg', [
  {name: "Default", duration: 0, delay: 0},
  {name: "AnimateIndusPhysicianfadein", duration: 0.75, delay: 0},
  {name: "IndusPhysiciantoComp", duration: 1.5, delay: 0.25},
  {name: "AnimateMtg", duration: 1, delay: 0},
  {name: "AnimateIndusPhysicianComptoPhysician", duration: 1.5, delay: 1},
  {name: "AnimateTeamgenerateReporttoRecords", duration: 1, delay: 0.5}, 
  {name: "ReportTeamtoRecords", duration: 1, delay: 0},
  {name: "AnimatePersonnelfadeinInTeam", duration: 0.75, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const weeklywrkplcinspctsteps = ['weeklywrkplcinspct', [
  {name: "Default", duration: 0, delay: 0},
  {name: "OfficertoFacilities", duration: 1, delay: 0 },
  {name: "AnimateOfficerinspectFacilities", duration: 1.5, delay: 0, delayAccumulated: 1},
  {name: "AnimateOfficerFacilitiestoTeam", duration: 1, delay: 0, delayAccumulated: 2.5},
  {name: "AnimateTeamgenerateReporttoRecords", duration: 0.75, delay: 0.35}, 
  {name: "ReportTeamtoRecords", duration: 1, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const prsnlAppntmntsteps = ['prsnlAppntmnt', [
  {name: "Default", duration: 0, delay: 0},
  {name: "AnimateTeamtoEmp", duration: 0.75, delay: 0.5},
  {name: "AnimateEmpturnTan", duration: 1.25, delay: 0},
  {name: "AnimateEmpturnBlue", duration: 0.75, delay: 0},
  {name: "AnimateEmptoTeam", duration: 0.75, delay: 0}, 
  {name: "AnimateTeamgenerateReporttoLSO", duration: 1, delay: 0.5}, 
  {name: "ReportTeamtoLSO", duration: 1.75, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const incdntRprtngsteps = ['incdntRprtng', [
  {name: "Default", duration: 0, delay: 0},
  {name: "AnimateEmpturnBlue", duration: 0.75, delay: 0},
  {name: "AnimateEmpFall", duration: 0.5, delay: 0},
  {name: "AnimateEmpCry", duration: 0.75, delay: 0},
  {name: "AnimateEmpStand", duration: 0.75, delay: 0},
  {name: "AnimateEmpSmile", duration: 0.75, delay: 0},
  {name: "AnimateTeamgenerateReporttoLSO", duration: 1.25, delay: 0}, 
  {name: "ReportTeamtoLSO", duration: 1.75, delay: 0.25},
  {name: "AnimateEnd", duration: 0, delay: 0}
]]
const activities = [defaultsteps, healthChecksteps, stressChecksteps, mnthlywrkplcinspctsteps, commttMtgsteps, weeklywrkplcinspctsteps, prsnlAppntmntsteps, incdntRprtngsteps, setupsteps]

const activitiesForDisplay = [
  { period: 'SETUP',
    activities: [ 
      { title: 'HEALTHCOMMITTEE', steps: setupsteps, posY: -48 }
    ] 
  },
  { period: 'ANNUAL',
    activities: [ 
      { title: 'HEALTHCHECK', steps: healthChecksteps, posY: -48 },
      { title: 'STRESSCHECK', steps: stressChecksteps, posY: -48 },
    ]
  },
  { period: 'MONTHLY',
    activities: [ 
      { title: 'WORKPLACEINSPECTION', steps: mnthlywrkplcinspctsteps, posY: -48 },
      { title: 'HEALTHCOMMITTEEMEETING', steps: commttMtgsteps, posY: -48 },
    ]
  },
  { period: 'WEEKLY',
    activities: [ 
      { title: 'WORKPLACEINSPECTION', steps: weeklywrkplcinspctsteps, posY: -48 },
    ]
  },
  { period: 'ADHOC',
    activities: [ 
      { title: 'PERSONNELAPPOINTMENT', steps: prsnlAppntmntsteps, posY: -48 },
      { title: 'INCIDENTREPORTING', steps: incdntRprtngsteps, posY: -268 },
    ]
  }
]
function actyDisplayCondition (acty) {
  switch (acty) {
    case setupsteps[0]:
      return needsSetup.value;
    case healthChecksteps[0]:
      return needsAnnlHlthChck.value;
    case stressChecksteps[0]:
      return needsAnnlStrssCheck.value;
    case mnthlywrkplcinspctsteps[0]:
      return needsMnthlyWrkPlcInspect.value;
    case commttMtgsteps[0]:
      return needsMnthlyHlthCmmttMeeting.value;
    case weeklywrkplcinspctsteps[0]:
      return needsWklyWrkPlcInspect.value;
    case prsnlAppntmntsteps[0]:
      return needsAdhocPrsnlReporting.value;
    case incdntRprtngsteps[0]:
      return needsAdhocIncdntReporting.value;
    default:
      return true;
  }
}

// icon2 = icon X2 if go horizontal, icon2 = icon Y2 if go vertical
function getArrowLineDuration (icon2, iconWidth, iconHeight, arrowX1, arrowY1, arrowX2, arrowY2, actyNm, stepNm, arrowHeadLength = 30) {
  const iconDuration = getActyStepDuration(actyNm, stepNm)
  let arrowTotalLength, iconMovingLength;  
  if (arrowX1 < arrowX2) { // icon goes right
    arrowTotalLength = Math.abs(arrowX2 + iconWidth - arrowX1) + arrowHeadLength
    iconMovingLength = arrowTotalLength + Math.abs(icon2 - arrowX2) + iconWidth
  } else if (arrowX1 > arrowX2) { // icon goes left
    arrowTotalLength = Math.abs(arrowX2 - arrowX1) + arrowHeadLength
    iconMovingLength = arrowTotalLength + Math.abs(icon2 - (arrowX2 - arrowHeadLength))
  } else if (arrowY1 < arrowY2) { // icon goes down
    arrowTotalLength = Math.abs(arrowY2 - arrowY1) + arrowHeadLength
    iconMovingLength = arrowTotalLength + Math.abs(icon2 - (arrowY2 + arrowHeadLength))
  } else { // icon goes up
    arrowTotalLength = Math.abs(arrowY2 - arrowY1) + arrowHeadLength
    iconMovingLength = arrowTotalLength + Math.abs(icon2 - (arrowY2 - arrowHeadLength)) + iconHeight
  }
  const speed = iconMovingLength/iconDuration;
  return arrowTotalLength/speed
}

function getArrowPathDuration (arrowBodyLength, icon2, arrow2, actyNm, stepNm, arrowHeadLength = 30) {
  // if icons moves horizontally inside box: icon2 = iconX2, arrow2 = arrowX2
  // if icons moves vertically inside box: icon2 = iconY2, arrow2 = arrowY2
  const iconDuration = getActyStepDuration(actyNm, stepNm)
  const arrowTotalLength = arrowBodyLength + arrowHeadLength
  const iconMovingLength = arrowTotalLength + Math.abs(icon2 - arrow2)
  const speed = iconMovingLength/iconDuration;
  return arrowTotalLength/speed
}

function getArrowPathDurationByIconDistance (arrowBodyLength, iconMovingLength, actyNm, stepNm, arrowHeadLength = 30) {
  const iconDuration = getActyStepDuration(actyNm, stepNm)
  const arrowTotalLength = arrowBodyLength + arrowHeadLength
  const speed = iconMovingLength/iconDuration;
  return arrowTotalLength/speed
}

let currentStep = ref(0);
let selectedActvt = ref(null);
let timeoutIds = [];
function animate (actvt) {
  // if acty not needed for company size, return
  if (!actyDisplayCondition(actvt[0])) {
    timeoutIds.forEach(timeoutId => {
      clearTimeout(timeoutId)
    })
    return
  }

  // if the count is not required, then do not even show it
  let steps = actvt[1]
  selectedActvt.value = actvt[0];
  if (actvt[0] === healthChecksteps[0] && !needsIndusPhysician.value) { 
    steps = healthCheckstepsNoPhysician[1]
  }
  // reset
  let duration = steps.map(x => x.duration + x.delay);
  currentStep.value = -1;
  timeoutIds.forEach(timeoutId => {
    clearTimeout(timeoutId)
  })

  for(let i=0; i < steps.length; i++){
    const stepTime = duration.slice(0, i).reduce(getStepTime, 0);
    timeoutIds.push(setTimeout(() => { 
      currentStep.value++ 
    }, stepTime*1000))
  }
}

watch(size, (newSize) => {
  console.log(newSize)
  if (selectedActvt.value) {
    animate(selectedActySteps.value)
  } 
})
watch(coType, (newCoType) => {
  console.log(newCoType)
  if (selectedActvt.value) {
    animate(selectedActySteps.value)
  } 
})

function getStepTime (total, stepTime) {
  return total + stepTime;
}
function getActyStepIndex (actySteps, stepNm) {
  return actySteps.findIndex(x => x.name === stepNm)
}
function getActyStepByStepNm (actySteps, stepNm) {
  const stepIndex = getActyStepIndex(actySteps, stepNm)
  return actySteps[stepIndex]
}
function getActyStepDuration (actySteps, stepNm) {
  const step = getActyStepByStepNm(actySteps, stepNm)
  return step.duration
}
const selectedActySteps = computed(() => {
  return activities.find(x => x[0] === selectedActvt.value)
})
const selectedActyStepsNoEmpty = computed(() => {
  let result = selectedActySteps.value[1].map(x => x.name)
  if (selectedActvt.value === healthChecksteps[0] && !needsIndusPhysician.value) {
    result = result.slice(0, 8)
  }
  return result.filter(step => !step.includes('Animate'))
})

const teamLoop = computed(() => {
  return [
    { rectX: 56, rectY: 60, rectWidth: 160,  conditionInactive: !nbHlthSftyManager.value, iconX: 60, iconY: 64, iconWidth: 150, iconType: 'hlthSftyManager', textX: 96, text1Y: 88, text2Y: 104, text1Content: 'HEALTH&SAFETY', showOnLeft: false, showOnBottom: false, deviateX: 0, deviateY: 0 },  
    { rectX: 230, rectY: 60, rectWidth: 110, conditionInactive: !nbCmpnyMgmt.value, iconX: 306, iconY: 64, iconWidth: 30, iconType: 'wrkplcManager', textX: 236, text1Y: 88, text2Y: 104, text1Content: 'COMPANYMANAGER1', showOnLeft: false, showOnBottom: false, deviateX: 0, deviateY: 0 },
    { rectX: 56, rectY: 132, rectWidth: 160, conditionInactive: !nbHlthSftyPromoter.value, iconX: 60, iconY: 136, iconWidth: 150, iconType: 'hlthSftyPromoter', textX: 96, text1Y: 160, text2Y: 178, text1Content: 'HEALTH&SAFETY', showOnLeft: false, deviateX: 0 },
    { rectX: 230, rectY: 132, rectWidth: 110, conditionInactive: !nbHlthPromoter.value, iconX: 306, iconY: 136, iconWidth: 30, iconType: 'hlthPromoter', textX: 236, text1Y: 160, text2Y: 178, text1Content: 'HEALTH' },
    { rectX: 34, rectY: 204, rectWidth: 96, conditionInactive: !nbSftyOfficer.value, iconX: 40, iconY: 208, iconWidth: 40, iconType: 'sftyOfficer', textX: 74, text1Y: 232, text2Y: 250, text1Content: 'SAFETYOFFICER1', showOnLeft: false, showOnBottom: false, deviateX: 0, deviateY: 0 },
  ]
})

function reset () {
  selectedActvt.value = defaultsteps[0];
  currentStep.value = 0;
  coType.value = "office"
  size.value = 50
}

// tooltip
const keepTooltipsIds = computed(() => {
  return keepTooltips.value.length > 0 ? keepTooltips.value.map(x => x.id) : []
})

function showTooltipByOpt (event, showOnLeft, showOnBottom, deviateX, deviateY, tooltipWidthCustom = 0) {
  showTooltip(event, showOnLeft, showOnBottom, deviateX, deviateY, tooltipWidthCustom)
}

function getTooltipContent (item) {
  switch (item) {
    case 'actysetup': return 'ACTYSETUP';
    case 'actyhealthCheck': return 'ACTYHLTHCHECK';
    case 'actystressCheck': return 'ACTYSTRESSCHECK';
    case 'actymnthlywrkplcinspct': return 'ACTYMTHLYINSP';
    case 'actycommttMtg': return 'ACTYMTHLYMTG';
    case 'actyweeklywrkplcinspct': return 'ACTYWKLYINSP';
    case 'actyprsnlAppntmnt': return 'ACTYAPNRPT';
    case 'actyincdntRprtng': 
      if (size.value < 10) return 'ACTYINCDRPT';
      else if (size.value < 50 && nbHlthPromoter.value > 0) return 'ACTYINCDRPT1TYPE1';
      else if (size.value < 50 && nbHlthSftyPromoter.value > 0) return 'ACTYINCDRPT1TYPE2';
      else return 'ACTYINCDRPT2';
    case 'EmptoClinic': return 'HLTHCHECK';
    case 'hlthClinic': return 'HLTHCLINIC';
    case 'indusPhysician': return 'PHYSICIAN';
    case 'LSO': return 'LSO';
    case 'ReportLaptoptoEmp': return 'STRESSCHECKRESULT';
    case 'ReportLaptoptoIndusPhysician': return 'STRESSCHECKRESULT';
    case 'ReportClinictoEmp': return 'HLTHCHCKRESULT';
    case 'ReportEmptoLaptop': return 'STRESSCHECK';
    case 'ReportIndusPhysiciantoEmp': return 'STRESSCHECKRESULT';
    case 'ReportIndusPhysiciantoLSO': return 'STRESSSUMMARYREPORT';
    case 'safeBox': return 'SECURESTORAGE';
    case 'employees':
      switch (selectedActvt.value){
        case healthChecksteps[0]: return 'EMPLOYEESHLTH';
        case stressChecksteps[0]: return 'EMPLOYEESSTRESS';
        case prsnlAppntmntsteps[0]: return 'EMPLOYEESAPPNT';
        case defaultsteps[0]: return 'EMPLOYEES';
        case null: return 'EMPLOYEES';
        default: return 'EMPLOYEESALL';
      }
    default: break;
  }  

  switch (selectedActvt.value) {
    case setupsteps[0]:
      switch (item) {
        case 'ReportTeamtoRecords': return 'HEALTHCOMMITTEEPOLICY';
      }
    break;
    case healthChecksteps[0]:
      switch (item) {
        case 'ReportClinictoIndusPhysician': return 'HLTHCHCKRESULT';
        case 'ReportIndusPhysiciantoTeam': return 'HLTHEVALUATEREPORT';
        case 'ReportTeamtoRecords': return 'HLTHEVALUATEREPORT';
        case 'ReportTeamtoLSO': return 'HLTHSUMMARYREPORT';
      }
    break;
    case stressChecksteps[0]:
      switch (item) {
        case 'ReportIndusPhysiciantoTeam': return 'STRESSSUMMARYREPORT';
        case 'ReportTeamtoLSO': return 'STRESSSUMMARYREPORT';
      }
    break;
    case mnthlywrkplcinspctsteps[0]:
      switch (item) {
        case 'ReportTeamtoRecords': return 'MTHLYINSPCHECKLIST';
        case 'ReportIndusPhysiciantoTeam': return 'MTHLYINSPCHECKLIST';
      }
    break;
    case commttMtgsteps[0]:
      switch (item) {
        case 'ReportTeamtoRecords': return 'COMMTTMTGSUMMARY';
      }
    break;
    case weeklywrkplcinspctsteps[0]:
      switch (item) {
        case 'ReportTeamtoRecords': return 'WKLYINSPCHECKLIST';
      }
    break;
    case prsnlAppntmntsteps[0]:
      switch (item) {
        case 'ReportTeamtoLSO': return 'APPOINTREPORT';
      }
    break;
    case incdntRprtngsteps[0]:
      switch (item) {
        case 'ReportTeamtoLSO': return 'INCIDENTSICKREPORT';
      }
    break;
  }
}

function getTooltipPosY (item) {
  if (item === 'employee-title') {
    switch (selectedActvt.value) {
      case healthChecksteps[0]: return -174;
      case stressChecksteps[0]: return -174;
      case defaultsteps[0]: return -324;
      case null: return -324;
      default: return -76;
    }
  }
}

let isFullScreen = ref(false)

function openFullscreen() {
  const elem = document.querySelector("#app");
  const usersBrowser =
    elem.requestFullscreen ||
    elem.webkitRequestFullscreen ||
    elem.mozRequestFullscreen ||
    elem.msRequestFullscreen;
    isFullScreen.value = true
  if(document.fullscreenElement){
    document.exitFullscreen();
    isFullScreen.value = false
  } else {
    usersBrowser.call(elem)
  }
}

// close tooltip when number of employees change
</script>

<style>
.shown {
  opacity: 1;
}
.vue-slider-mark-label {
  color: #504C00 !important;
}
.vue-slider {
  cursor: pointer;
  margin-left: 5px;
}
.vue-slider-dot {
  z-index: 1;
}
.vue-slider-process {
  background: #928d22;
}
input {
  accent-color: #928d22;
}
#hlthCheckSummaryReport.inactive, #indusphysician.inactive {
  opacity: 0.5;
}
#app:fullscreen {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #504C00;
  background-color: #726d0e;
  background-image: url("./assets/texture_depthPattern4.jpg");
}
</style>

<style scoped>
* {
  font-size: 12px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #494127;
}
ol {
  margin-top: 0;
}
.svg-text-light {
  fill: #FFFFFF;
}
.text-light {
  color: #FFFFFF;
}
.bottom-container {
  display: flex;
  margin: -12px 16px 0 16px;
}
.animation-title-container {
  display: flex;
  justify-content: left;
  padding: 16px 0 0 45px;
  height: 21px;
}
.animation-title {
  display: flex;
  gap: 15px;
}
.animation-title-container .label {
  text-align: left;
}
.top-container {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 48px;
  padding: 0 20px 0px 20px;
}
.flexend-container{
  display:flex;
  height:930px;
  align-items: flex-end;
}
.activities-container {
  padding-left: 36px;
  line-height: 16px;
}
.svg-main {
  position: absolute;
  top: 110px;
  left: 10px;
  height: 830px;
  width: 100%;
}
.border-box {
  fill: #C4BD97;
}
.border-box.emp-num {
  fill: #C4BD97;
  stroke: #6E6900;
  stroke-width: 1;
}
.big-block {
  width: 408px;
}
.shadow-block {
  filter:
    url(#shadow-block-inner-top)
    url(#shadow-block-inner-top2)
    url(#shadow-team-inner-right)
    url(#shadow-block-inner-bottom)
    url(#shadow-team-inner-left)
    drop-shadow(3px 3px 4px rgba(0,0,0,.5));
}
.shadow-inner {
  box-shadow: 
    -1px -1px 6px rgba(255,255,255,.3),
		1px 2px 6px rgba(0,0,0,.3),
		2px 3px 9px rgba(0,0,0,.6),
		inset 0px -5px 1px rgba(0,0,0,.3),
		inset -2px 0px 2px rgba(0,0,0,.3),
		inset -1px -1px 4px rgba(255,255,255,1),
		inset 2px 4px 4px rgba(255,255,255,1),
		inset 1px 1px 6px rgba(255,255,255,.3);
}
.shadow-line {
  filter: 
    url(#shadow-line-block-inner-top)
    url(#shadow-line-block-inner-top2)
    url(#shadow-line-block-inner-bottom)
    drop-shadow(6px 4px 3px rgba(0, 0, 0, .5));
}
.shadow-line-left {
  filter:
    url(#shadow-line-block-inner-left)
    url(#shadow-line-block-inner-left2)
    url(#shadow-line-block-inner-right)
    drop-shadow(4px 0px 3px rgba(0, 0, 0, .5));
}
.shadow-line-curve-up {
  filter:
    url(#shadow-line-block-inner-left)
    url(#shadow-line-block-inner-left2)
    url(#shadow-team-inner-right)
    drop-shadow(4px 3px 3px rgba(0, 0, 0, .5));
}
.shadow-line-curve-down {
  filter:
    url(#shadow-line-block-inner-left)
    url(#shadow-line-block-inner-left2)
    url(#shadow-line-block-inner-right)
    drop-shadow(5px 4px 3px rgba(0, 0, 0, .5));
}
.shadow-line-both {
  filter:
    url(#shadow-line-right)
    drop-shadow(-4px 0px 1px rgba(0, 0, 0, .1));
}
.shadow-dot {
  filter: 
  url(#shadow-dot-inner-top)
  url(#shadow-dot-inner-right)
    ;
}
.shadow-dot.fade {
  opacity: 0.3;
}
.container-box {
  background: #C4BD97;
  border-radius: 8px;
  box-shadow: 
    -1px -1px 6px rgba(255,255,255,.3),
		1px 2px 6px rgba(0,0,0,.3),
		2px 3px 9px rgba(0,0,0,.6),
    inset 0px 4px 2px rgba(196,189,151,1),
		inset 0px 9px 5px rgba(255,255,255,.5),
		inset -4px 0px 6px rgba(0,0,0,.5),
		inset 0px -4px 1px rgba(0,0,0,.3),
    inset 6px -1px 6px rgba(0,0,0,.2)
		/* inset -1px -1px 4px rgba(255,255,255,1), */
		/* inset 2px 1px 6px rgba(0,0,0,1); */
    ;
}
.externalbox {
  margin-top: 20px;
  margin-left: 20px; 
  width: 500px;
}
.animation-controller {
  color: #F9F9F1;
}
button {
  border-radius: 5px;
  padding: 4px;
  background-color: #c8c58c;
  cursor: pointer;
}
.activity-container {
  display: grid;
  grid-template-columns: 80px 1fr;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px;
  padding-left: 0;
  height: 64px;
  background-color: #555025;
  border: 2px solid #C4BD97;
  border-radius: 8px;
}
.activity-container .label {
  margin-left: 8px;
}
.activity-container.acty-2 {
  height: 136px;
}
.label {
  text-align: center;
  font-weight: bold;
  font-size:14px;
  color: #F9F9F1;
  margin: auto;
}
#label-title {
  text-align: center;
  font-size:23px;
  font-weight: bold;
  color: #F9F9F1;
}
.actbtn-containers {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.actbtn-connector-container {
  display: flex;
  align-items: center;
  margin-left: -218px;
}
.actbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
	background-color: hsl(57, 100%, 22%);
  color: #F9F9F1;
  border: 2px solid #C4BD97;
	border-radius: 8px;
  filter: brightness(115%);
  box-shadow:
    -1px -1px 6px rgba(255,255,255,.3),
		1px 2px 6px rgba(0,0,0,.3),
		2px 3px 9px rgba(0,0,0,.6);  
}
.actbtn.inactive {
  pointer-events: none;
}
.actbtn.tooltip-opt {
  width: 116px;
  display: flex;
  justify-content: space-around;
}
.button-normal {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  padding: 2px 6px;
  border: 1px solid #a19d4e !important;
  border-radius: 5px;
  background-color: #d9d7af;
  cursor: pointer;
}
.locale, .reset {
  width: 80px;
  height: 44px;
}
.locale, #fullscreen, .reset {
  background: none;
  border: none;
  border-radius: 0;
  padding: 0;
}
.locale div, #fullscreen div, .reset div {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #C4BD97;
  padding: 0 10px;
  height: 21px;
}
.locale:hover, #fullscreen:hover, .reset:hover {
  background: #6E6900;
}
.locale span, .reset span {
  color: white;
}
.text-locale-jp {
  font-family: -apple-system, blinkMacSystemFont, Helvetica Neue, Segoe UI, Yu Gothic, YuGothic, 游ゴシック体, Meiryo, sans-serif;
  font-size: 13px;
  font-weight: 500;
}
.memberboxtitle-large.text-locale-jp3 {
  font-family: -apple-system, blinkMacSystemFont, Helvetica Neue, Segoe UI, Yu Gothic, YuGothic, 游ゴシック体, Meiryo, sans-serif;
  font-size: 14px;
  font-weight: 600;
}
.memberboxtitle-large.text-locale-jp2 {
  font-family: -apple-system, blinkMacSystemFont, Helvetica Neue, Segoe UI, Yu Gothic, YuGothic, 游ゴシック体, Meiryo, sans-serif;
  font-size: 15px;
  font-weight: 600;
}
.memberboxtitle-large.text-locale-jp {
  font-family: -apple-system, blinkMacSystemFont, Helvetica Neue, Segoe UI, Yu Gothic, YuGothic, 游ゴシック体, Meiryo, sans-serif;
  font-size: 16px;
  font-weight: 600;
}
.text-locale-jp-mid {
  font-family: -apple-system, blinkMacSystemFont, Helvetica Neue, Segoe UI, Yu Gothic, YuGothic, 游ゴシック体, Meiryo, sans-serif;
  font-size: 15px;
  font-weight: 600;
}
.text-locale-jp-large {
  font-family: -apple-system, blinkMacSystemFont, Helvetica Neue, Segoe UI, Yu Gothic, YuGothic, 游ゴシック体, Meiryo, sans-serif;
  font-size: 23px;
  letter-spacing:4px;
  margin-left:10px;
}
.actbtn.acty {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0 16px;
  width: 140px;
  height: 64px;
  color: #F9F9F1;
  font-weight: 100;
  box-shadow:
    -1px -1px 6px rgba(255,255,255,.3),
		1px 2px 6px rgba(0,0,0,.3),
		2px 3px 9px rgba(0,0,0,.6),    
    /* shadow right */
    inset -10px 0px 4px rgba(0,0,0,.2),
		inset -4px 0px 4px rgba(0,0,0,.3),
    /* shadow top */
		inset 0px 4px 4px rgba(110,105,0,1),
		inset 0px 6px 4px rgba(255,255,255,.6),
    /* shadow bottom */
    inset 0px -4px 2px rgba(0,0,0,.3),
    /* shadow left */
    inset 2px 0px 3px rgba(0,0,0,.7);
}
.actbtn.acty.text-locale-jp#actystressCheck {
  font-weight: 500;
}
.actbtn.reset {
  width: 88px;
  height: 44px;
}
/* svg */
.external-box {
  width: 200px;
  height: 170px;
}
#indusPhysician .external-box {
  width: 104px;
}
.comp-object-box {
  width: 188px;
  height: 86px;
}
.memberboxtitle {
  font-weight: bold;
}
.memberboxtitle-large {
  font-weight: bold;
  font-size: 14px;
}
.team-member-box { 
  width: 120px;
  height: 56px;
  fill: #C4BD97;
  /* fill: #EFEEDD; */
  filter:
    url(#shadow-team-inner-top)
    url(#shadow-team-inner-right)
    url(#shadow-team-inner-bottom)
    url(#shadow-team-inner-left)
    drop-shadow(1px 1px 4px rgba(0,0,0,.5));
}
.icon-member {
  width: 25px;
  height: 65px;
}
text {
  fill: #494127;
}
#records {
  cursor: pointer;
}
#recordstext {
  text-align: center;
  color: #494127;
}
.arrowtan {
  stroke: #C4BD97;
  stroke-width: 13px;
  fill: transparent;
}
.background-white {
  fill: #EBF5FF;
}
.background-blue {
  fill: #D6E6F3;
}
.background-green {
  fill: #555025;
}
.background-tan {
  fill: rgb(178,172,137);
}
.report-background-small {
  width: 23px;
  height: 30px;
}
.step-number {
  font-size: 12px;
  font-weight: bold;
}
.personnel-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.icon-fade-in {
  animation-name: iconFadeIn;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes iconFadeIn {
  0% {opacity: 0;}
  100% {opacity: 1;}
}
.icon-fade-out {
  animation-name: iconFadeOut;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes iconFadeOut {
  0% {opacity: 1;}
  100% {opacity: 0;}
}
.icon-fade-out-half {
  animation-name: iconFadeOutHalf;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes iconFadeOutHalf {
  0% {opacity: 1;}
  100% {opacity: 0.3;}
}
.icon-fade-out-light {
  animation-name: iconFadeOutLight;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes iconFadeOutLight {
  0% {opacity: 1;}
  100% {opacity: 0.6;}
}
@keyframes empBlink {
  0% {filter: brightness(1);}
  50% {filter: brightness(1.2);}
  100% {filter: brightness(1);}
}
.emp-to-comp-edge {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(114px, 32px);
}
.emp-comp-to-clinic {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(896px, 32px);
}
.emp-take-healthcheck-blink {
  animation-name: empBlink; 
  animation-fill-mode: forwards;
}
.emp-take-healthcheck-move {
  animation-name: moveCurve; 
  animation-fill-mode: forwards;
  offset-path: path("M0,0 C154,0 154,-56 10,-68"); 
  offset-rotate: 0deg;
}
.emp-clinic-to-comp {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(104px,32px);
}
.emp-to-comp-center {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(-10px,68px);
}
@keyframes moveCurve {
  100% {offset-distance: 100%;}
}
.health-result-fade-in {
  opacity: 0;
  animation-name: iconFadeIn;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
  transform: translateX(882px);
}
.animate-report-clinic-to-emp {
  opacity: 1;
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 C0,-80 -882,-80 -958,30");
  offset-rotate: 0deg;
}
.animate-report-clinic-to-physician-fade-in {
  transform: translateY(276px);
  animation-name: iconFadeIn;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}
.animate-report-clinic-to-physician {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateY(0);
}
.animate-report-physician-to-records {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M 0 0 C 0 0, 0 150, -510 150");
  offset-rotate: 0deg;
}
.report-fade-out {
  opacity: 1;
  transform: translateY(0);
  animation: iconFadeOutHalf 1s ease-out 1.5s;
  animation-fill-mode: forwards;
}
.animate-report-physician-to-team {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateX(-880px);
}
.animate-report-physician-to-team-healthcheck {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateX(-872px);
}
.animate-team-to-lso {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 V-144 C0,-258 119,-258 814,-258");
  offset-rotate: 0deg;
}
.animate-team-to-lso-healthcheck {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 V-130 C0,-216 200,-210 780,-210");
  offset-rotate: 0deg;
}
.animate-team-to-records-evaluate {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 V128 C0,228 100,206 258,206");
  offset-rotate: 0deg;
}
.animate-team-to-records {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 V80 C0,178 100,158 242,158");
  offset-rotate: 0deg;
}
.animate-report-emp-to-laptop {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateX(429px);
}
.animate-report-laptop-to-emp {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateX(-430px);
}
.animate-report-laptop-to-physician {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 C0,0 510,-48 530,-246 V-356");
  offset-rotate: 0deg;
}
.animate-physician-to-team {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateX(-860px);
}
.animate-physician-comp-to-physician {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateX(0px);
}
.animate-physician-to-facilities {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 C0,0 0,-70 -500,-70");
  offset-rotate: 0deg;
}
.animate-physician-inspect-facilities {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M-500,-70 C-500,-70 -660,-70 -660,-100 C-660,-100 -660,-106 -500,-100");
  offset-rotate: 0deg;
}
.animate-physician-facilities-to-physician {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M-500,-100 C-500,-70 0,-70 0,0");
  offset-rotate: 0deg;
}
.animate-hlthofficer-to-facilities {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M0,0 C0,-132 228,-132 228,-132 H408");
  offset-rotate: 0deg;
}
.animate-hlthofficer-inspect-facilities {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M408,-132 C600,-132 600,-168 508,-168 C508,-168 480,-168 470,-160 C450,-150 440,-138 400,-132");
  offset-rotate: 0deg;
}
.animate-hlthofficer-facilities-to-team {
  animation-name: moveCurve;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  offset-path: path("M400,-132 H228 C228,-132 0,-132 0,0");
  offset-rotate: 0deg;
}
.animate-emp-to-team-officer {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translateY(-308px);
}
.animate-emp-to-team-hlthpromoter {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(10px,-432px);
}
.animate-emp-to-team-hlthSftypromoter {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(-134px,-432px);
}
.animate-team-to-emp-officer {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(80px, 308px);
}
.animate-team-to-emp-hlthpromoter {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(70px,432px);
}
.animate-team-to-emp-hlthSftypromoter {
  transition-property: transform;
  transition-timing-function: linear;
  transform: translate(214px,432px);
}

.animate-emp-fall {
  animation-name: moveFall; 
  animation-fill-mode: forwards;
  animation-timing-function: ease-in;
  offset-path: path("M0,0 H44 l5 14"); 
  offset-rotate: 0deg;
}
@keyframes moveFall {
  100% {
    offset-distance: 100%;
  }
}
.emp-position {
  transition-property: transform;
  transform: rotate(0deg);
  transition-timing-function: ease-in-out; 
}
.animate-emp-fall .emp-position {
  transform: rotate(90deg);
}
.animate-emp-stand .emp-position {
  transform: rotate(0deg) translate(-5px,-14px);
}
.emp-emotion {
  stroke: black;
  stroke-width: 1;
}
.strike-fall {
  animation-name: showHideStrike;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-duration: 0.1s;
  animation-delay: 0.1s;
  opacity: 0;
}
@keyframes showHideStrike {
  0% {opacity: 1;}
  99% {opacity: 1;}
  100% {opacity: 0;}
}
.delay-questionmark {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-delay: 2s;
}
.fade-in {
  animation-name: fadeIn;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  to {stroke-dashoffset: 0;} 
}
.arrow-head-visible {
  marker-end: url(#arrowhead);
}
.show-arrow-head {
  animation-name: showArrowHead;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  marker-end: none;
}
@keyframes showArrowHead {
  0% {marker-end: none;}
  95% {marker-end: none;}
  100% {marker-end: url(#arrowhead);}
}
.line {
  width: 160px;
  border: 1px solid #908E34;
  align-self: center;
  margin-left: 25px;
}
.inactive {
  opacity: 0.5;
}
.cursor-pointer {
  cursor: pointer;
}
.inactivemember {
  opacity: 0.5;
}
.filter-title {
  margin-left: 10px;
  font-weight:700;
  height: 20px;
  margin-top:2px;
}
.filter-subtitle {
  display: flex;
  align-items: center;
}
.filter-subtitle input[type="radio" i] {
  margin-left: 0px;
}
.filter-subtitle:first-child {
  width: 80px;
}
.filter-subtitle:nth-child(2) {
  width: 70px;
}
.hasTooltipDetail:hover {
  text-decoration: underline;
  cursor: pointer;
}
.actbtn:not(.inactive):not(:has(.tooltip-question-mark:hover)):hover,
.actbtn.activeActvt
 {
  background-color: #C4BD97;
  color: #494127;
}
.actbtn.acty:not(.inactive):not(:has(.tooltip-question-mark:hover)):hover,
.actbtn.acty.activeActvt
 {
  font-weight: 500;
  box-shadow:
    -1px -1px 6px rgba(255,255,255,.3),
		1px 2px 6px rgba(0,0,0,.3),
		2px 3px 9px rgba(0,0,0,.6),    
    /* shadow right */
    inset -8px 0px 6px rgba(0,0,0,.2),
		inset -4px 0px 4px rgba(0,0,0,.3),
    /* shadow top */
		inset 0px 4px 4px rgba(196,189,151,1),
		inset 0px 6px 3px rgba(255,255,255,1),
    /* shadow bottom */
    inset 0px -4px 3px rgba(0,0,0,.1),
    /* shadow left */
    inset 1px 0px 3px rgba(0,0,0,1);
}
.actbtn:hover svg {
  fill: #494127;
}
.tooltip-question-mark {
  position: absolute;
  cursor: pointer;
}
.tooltip-question-mark.mark-animation-title {
  position: relative;
}
.tooltip-question-mark svg path:first-child,
.tooltip-question-mark-svg path:first-child {
  fill: #C4BD97;
}
.tooltip-question-mark svg path:last-child,
.tooltip-question-mark-svg path:last-child {
  fill: hsl(57, 100%, 22%);
}
.tooltip-question-mark svg:hover path:first-child,
.tooltip-question-mark svg.tooltip-active path:first-child,
.tooltip-question-mark-svg:hover path:first-child,
.tooltip-question-mark-svg.tooltip-active path:first-child {
  fill: #555025;
}
.tooltip-question-mark svg:hover path:last-child,
.tooltip-question-mark svg.tooltip-active path:last-child,
.tooltip-question-mark-svg:hover path:last-child,
.tooltip-question-mark-svg.tooltip-active path:last-child {
  fill: #C4BD97;
}
.tooltip-question-mark-svg {
  cursor: pointer;
}
.company-container {
  height: 894px;
  background-color: #555025;
  border: 4px solid #C4BD97;
  border-radius: 10px;
}
.filter-content {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 20px;
  padding: 5px;
  height: 64px;
  width: 788px;
}
#filter-type {
  display: flex;
  gap:15px;
  margin-left: 10px;
  margin-top:1px;
}
.border-hover {
  stroke: #3886c5;
  stroke-width: 1;
}
.instruction {
  color:  #F9F9F1;
  width: 400px;
  margin-left: 15px;
}
.report {
  filter: drop-shadow(4px 4px 4px rgba(0,0,0,.4));
}
.prev-report {
  opacity: 0.3;
}
.prev-report-box {
  width: 34px;
  height: 33px;
  fill: none;
  /* fill: #d1ca9f;
  stroke: #E2E0C2; */
  fill: none;
  stroke: #928d22;
  stroke-width: 3px;
  stroke-dasharray: 10px;
  stroke-dashoffset: 50px;
}
.prev-report-box-small {
  width: 30px;
  height: 33px;
  stroke-dasharray: 6px;
  stroke-dashoffset: 20px;
}
.btn-hover:hover {
  cursor: pointer;
}
.container-animation-details {
  display: flex;
  align-items: center;
  padding: 0 8px 0 4px;
  width: 188px;
}
.container-animation-animate {
  display: flex;
  align-items: center;
  width: 94px;
} 

#fullscreen {
  width: 44px;
  height: 44px;
}
.confidentialtext {
  color: #efeedd;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  border: 1px solid #A09914;
  background-color: #e2e0c2;
  border-radius: 5px;
  color: #504C00;
}
</style>